import {observable, action, computed, ObservableMap, makeObservable, observe} from 'mobx';
import {ProcedureRequester} from './RequestApi/ProcedureRequester'
import {ProjectRequester} from "./RequestApi/ProjectRequester";
import {generalStore, modalStore, editorStore, history, projectStore} from '../index'
import Utility from "../Utility";
import Cookies from "js-cookie";
import {GeneralStore} from "./GeneralStore";
import {socket} from "./SocketStore";
import {
    procedureNodeTypeEnum,
    inputTypeEnum,
    sessionStatusEnum,
    procedureTypeEnum,
    runProcedureInEnum,
    languageEnum,
    editorNodeTypeEnum,
    ttsLanguagesEnum,
    responseEnum,
    uploadStatusEnum
} from "../serverClientShared/sharedEnums";
import {v4 as uuidv4} from 'uuid';
import sharedUtils, {editProcedureText, getProcedureText, getNodeMedia} from "../serverClientShared/sharedUtils";
import {DATA_INTERVAL} from "./DataStore";
import {routes} from "../App";
import {
    AudioConfig,
    SpeakerAudioDestination,
    SpeechConfig,
    SpeechSynthesizer
} from "microsoft-cognitiveservices-speech-sdk";
import {GeneralRequester} from "./RequestApi/GeneralRequester";
import {GroupsRequester} from "../Components/Domain/Groups/GroupsRequester";


const SESSION_PLAYER_INTERVAL = 10;
const ONE_MINUTE = 60 * 1000;
const socketMouseDelay = 100;
const socketUpdateDelay = 300;

const colorsArray = [
    "#f44336",
    "#e81e63",
    "#9c27b0",
    "#3f51b5",
    "#03a9f3",
    "#009688",
    "#8bc24a",
    "#fec007",
];

export class ProcedureStore {

    uploadStatus = false;
    connected3DModels = [];
    selected3DModel = null;
    runProcedureIn3D = false;
    doceboParams = null;
    isEmbedProcedureModalOpen = false;
    ttsMuted = false;
    ttsToken = '';
    ttsTokenExpiration = '';
    ttsRegion = '';
    speakingInterval = null;
    ttsPlayer = null;
    sharingId = "";
    embedId = "";
    deletePath = "";

    sidebar = false;
    previewSidebar = false;
    selectionMenu = false;
    selection = null;
    play3d = false;
    isWebOnly = false;
    warningPopupPreviewedFile = null;

    currentIsPublished = true;
    currentProcedureSessions = [];
    areSessionsLoaded = false;
    currentProcedure = {};
    accessSourcesKey = null;
    accessSourcesRequest = null;
    editorSaveCount = 0;
    currentPreviewedProcedure = {};
    currentNode = {};
    currentPreviewedNode = {};
    currentStepIndex = 0;
    currentPreviewedStepIndex = 0;
    currentMedia = -1;
    lastEdits = {
        user: "",
        date: new Date()
    };
    procedureViews = 0;
    latestView = null;
    procedureVersions = [];
    editingVersions = [];
    playerHistory = [];
    playerHistoryPreview = [];
    procedureUserDefinedInteractions = new Map();

    procedureEdits = {
        ProcedureName: "",
        ProcedureDescription: ""
    };

    updaterInterval = null;
    recordSession = true;
    forceNewSession = false;
    resumedSession = false;
    currentSession = {
        StartTimeStamp: new Date(),
        DebrifNodeEntries: [],
        Paused: false,
        Docebo: {...this.doceboParams},
        DeviceIdentifier: Cookies.get('deviceId_v2')
    };
    mostAbandoned = null;

    volume = 5;
    mute = false;
    taskRef = null;

    currentSessionIndex = 0;
    currentSessionMilliSecond = 0;
    sessionPlayerRunning = false;
    sessionViewerOpen = false;
    headerX = 0;
    headerY = 0;
    innerProcedureNextStepIds = [];
    innerProcedureParentProcedureIds = [];
    innerProcedurePreviousStepsIds = [];
    fetchedProceduresMap = new ObservableMap();
    showSupportingText = true;
    nestedProceduresFirstNode = null;

    sessionLogSteps = [];
    tempPayPerClick = {};
    editorWarningPopupNode = null;

    socketRoomId = "";
    lastMouseMoveTimeStamp = 0;
    lastUpdateTimeStamp = 0;
    favoriteProcedures = new ObservableMap();
    isUpdatingProcedureSessionLoading = false

    constructor(dataStore, projectStore) {
        makeObservable(this, {
            uploadStatus: observable,
            connected3DModels: observable,
            selected3DModel: observable,
            runProcedureIn3D: observable,
            doceboParams: observable,
            isEmbedProcedureModalOpen: observable,
            ttsMuted: observable,
            ttsToken: observable,
            ttsTokenExpiration: observable,
            ttsRegion: observable,
            speakingInterval: observable,
            ttsPlayer: observable,
            sharingId: observable,
            embedId: observable,
            deletePath: observable,
            sidebar: observable,
            previewSidebar: observable,
            selection: observable,
            play3d: observable,
            warningPopupPreviewedFile: observable,
            selectionMenu: observable,
            currentIsPublished: observable,
            currentProcedureSessions: observable,
            areSessionsLoaded: observable,
            currentProcedure: observable,
            editorSaveCount: observable,
            currentPreviewedProcedure: observable,
            currentNode: observable,
            currentPreviewedNode: observable,
            currentStepIndex: observable,
            currentPreviewedStepIndex: observable,
            currentMedia: observable,
            lastEdits: observable,
            procedureViews: observable,
            latestView: observable,
            procedureVersions: observable,
            editingVersions: observable,
            playerHistory: observable,
            playerHistoryPreview: observable,
            procedureEdits: observable,
            updaterInterval: observable,
            recordSession: observable,
            forceNewSession: observable,
            resumedSession: observable,
            currentSession: observable,
            mostAbandoned: observable,
            volume: observable,
            mute: observable,
            taskRef: observable,
            currentSessionIndex: observable,
            currentSessionMilliSecond: observable,
            sessionPlayerRunning: observable,
            sessionViewerOpen: observable,
            headerX: observable,
            headerY: observable,
            innerProcedureNextStepIds: observable,
            innerProcedureParentProcedureIds: observable,
            innerProcedurePreviousStepsIds: observable,
            fetchedProceduresMap: observable,
            showSupportingText: observable,
            sessionLogSteps: observable,
            tempPayPerClick: observable,
            editorWarningPopupNode: observable,
            socketRoomId: observable,
            lastMouseMoveTimeStamp: observable,
            lastUpdateTimeStamp: observable,
            procedureUserDefinedInteractions: observable,
            favoriteProcedures: observable,
            isWebOnly: observable,
            isUpdatingProcedureSessionLoading: observable,
            currentStep: computed,
            currentPreviewedStep: computed,
            totalSteps: computed,
            previewedTotalSteps: computed,
            nextStepAvailable: computed,
            nextPreviewedStepAvailable: computed,
            selectedNodes: computed,
            selectedPreviewedNodes: computed,
            defaultNode: computed,
            defaultPreviewedNode: computed,
            averageTime: computed,
            completedSessions: computed,
            availableNodeLanguages: computed,
            availablePreviewedNodeLanguages: computed,
            languagesVisibility: computed,
            updateDelayStillInEffect: computed,
            isSelectedLanguageDefault: computed,
            setCurrentProcedure: action,
            resetProcedure: action,
            resetInnerProcedures: action,
            resetPreviewedProcedure: action,
            startNewSession: action,
            setCurrentMedia: action,
            setCurrentPreviewedMedia: action,
            goToPrevious: action,
            goToPreviousPreviewed: action,
            goBackToParentProcedure: action,
            goNextToParentProcedure: action,
            restart2D: action,
            goToNext: action,
            goToNextPreviewed: action,
            goToNode: action,
            goToPreviewNode: action,
            addUserSelection: action,
            addUserPreviewedSelection: action,
            goNextBySelection: action,
            endProcedure: action,
            clearWarningAcknowledgements: action,
            startRecordedSession: action,
            updateSession: action,
            togglePauseProcedure: action,
            startNodeSession: action,
            editNodeSessionInput: action,
            addWarningAcknowledgementToSession: action,
            endNodeSession: action,
            getLastEdit: action,
            publishProcedure: action,
            unPublishProcedure: action,
            deleteProcedure: action,
            saveDashboardEdits: action,
            savePlayerSettings: action,
            saveThreeDSettings: action,
            addProcedureThumbnail: action,
            replaceProcedureMedia: action,
            replaceProcedureLink: action,
            getProcedureViews: action,
            getAllViews: action,
            deleteProcedureLanguage: action,
            getProcedureSessions: action,
            getProcedureVersions: action,
            editReleaseNotes: action,
            rollback: action,
            goToLog: action,
            tick: action,
            playSession: action,
            pauseSession: action,
            skipLog: action,
            resetSession: action,
            getSessionDuration: action,
            getMediaAddedToSession: action,
            toggleTtsMuted: action,
            getPayPerClick: action,
            getPayPerClickStatus: action,
            deletePendingPayPerClick: action,
            updatePayPerClick: action,
            updateMultipleConnections: action,
            beginSession: action,
            currentHas3D: computed,
            currentHas3DPreview: computed,
            getUserDefinedInteractions: action,
            getAttached3dItems: action,
            ensureConnectedModelsInMap: action,
            saveEditedProcedure: action,
            updatePreRequiredProcedures: action,
            getAvailableNodeLanguages: action,
            getProcedureSession: action,
            getFlowEditorStatus: action,
            updateFlowEditorStatus: action,
            getSocketMessage: action,
            stopGetSocketMessage: action,
            joinFlowEditRoom: action,
            leaveFlowEditRoom: action,
            sendAddUserMessage: action,
            sendRequestUserData: action,
            sendMouseMove: action,
            createNextEditingVersionOnClose: action,
            exitProcedureEditor: action,
            checkIfTooManyProcedureActiveEditors: action,
            goToEditor: action,
            buildEditorUrl: action,
            updateInteractionFolderName: action,
            updateInteractionFolders: action,
            createNewEmptyInteraction: action,
        });

        this.dataStore = dataStore;
        this.projectStore = projectStore;
        observe(this, "currentMedia", this.updateMediaInSession);
    }

    updateMediaInSession = (change, forcedFile) => {
        let file;
        if (!forcedFile) {
            if (
                !this.recordSession
                || change.oldValue === -1
                || !this.currentSession
                || getNodeMedia(this.currentNode, "NodeMediaFilesRefs", this.currentProcedure).FileRefs.length < 2    //if there are one or less media items
            ) {
                return;
            }
            file = getNodeMedia(this.currentNode, "NodeMediaFilesRefs", this.currentProcedure).FileRefs[this.currentMedia];
        } else {
            file = forcedFile;
        }
        if (!file) {
            return;
        }

        const currentSessionNode = this.currentSession.DebrifNodeEntries[this.currentSession.DebrifNodeEntries.length - 1] || {};
        if (!currentSessionNode?.NodeSubEvents) {
            currentSessionNode.NodeSubEvents = [];
        }
        currentSessionNode.NodeSubEvents.push({
            SubEventText: `selected media - ${file.FileName + '.' + file.FileExtension}`,
            SubEventTime: new Date(),
            IsError: false,
            MediaIndex: this.currentMedia
        });
    }

    get currentStep() {
        return this.selectedNodes.findIndex(n => n && this.currentNode && n.Identifier === this.currentNode.Identifier)
    }

    get currentPreviewedStep() {
        return this.selectedPreviewedNodes.findIndex(n => this.currentPreviewedNode && n.Identifier === this.currentPreviewedNode.Identifier)
    }

    get totalSteps() {
        return this.selectedNodes.length - 1
    }

    get previewedTotalSteps() {
        return this.selectedPreviewedNodes.length - 1
    }

    get nextStepAvailable() {
        if (!this.currentNode?.ConnectionsData?.length) {
            return false;
        }

        if (this.currentNode.ConnectionsData.length === 1) {
            return this.currentNode.ConnectionsData[0].ConnectedTo !== ""
        }

        return this.currentNode.userSelection;
    }

    get nextPreviewedStepAvailable() {
        if (!this.currentPreviewedNode?.ConnectionsData?.length) {
            return false;
        }

        if (this.currentPreviewedNode.ConnectionsData.length === 1) {
            return this.currentPreviewedNode.ConnectionsData[0].ConnectedTo !== ""
        }

        return this.currentPreviewedNode.userSelection;
    }

    get selectedNodes() {
        if (!this.currentProcedure.NestedNodes || this.currentProcedure.NestedNodes.length === 0) {
            return []
        }
        const nodes = [this.currentProcedure.NestedNodes[0]];
        let i = 0;
        while (this.getSelectedNodeCondition(this.currentProcedure.NestedNodes[i])) {
            let node = this.currentProcedure.NestedNodes[i];
            if (node.userSelection) {
                i = this.addSelectedNode(node, nodes);
            } else {
                i = this.addDefaultNode(node, nodes)
            }
            if (i < 0) {
                break
            }
        }
        return nodes
    }

    get currentHas3D() {
        return this.currentProcedure?.ThreeDModelsConnected && this.currentProcedure.ThreeDModelsConnected.length && (this.currentProcedure.AllowRun === runProcedureInEnum.BOTH || this.currentProcedure.AllowRun === runProcedureInEnum.THREE_D)
    }

    get currentHas3DPreview() {
        return this.currentPreviewedProcedure?.ThreeDModelsConnected && this.currentPreviewedProcedure.ThreeDModelsConnected.length && (this.currentPreviewedProcedure.AllowRun === runProcedureInEnum.BOTH || this.currentPreviewedProcedure.AllowRun === runProcedureInEnum.THREE_D)
    }

    getSelectedNodeCondition = node => {   //also checks for whether editor forgot to add any connections to multistep nodes or if the step is the final step
        if (!node?.ConnectionsData?.length) {
            return false
        }
        let connection = false;
        node.ConnectionsData.forEach(c => {
            if (c.ConnectedTo !== "") {
                connection = true
            }
        })
        return connection
    }

    get selectedPreviewedNodes() {
        if (!this.currentPreviewedProcedure.NestedNodes || this.currentPreviewedProcedure.NestedNodes.length === 0) {
            return []
        }
        const nodes = [this.currentPreviewedProcedure.NestedNodes[0]];
        let i = 0;
        while (this.getSelectedNodeCondition(this.currentPreviewedProcedure.NestedNodes[i])) {
            let node = this.currentPreviewedProcedure.NestedNodes[i];
            if (node.userSelection) {
                i = this.addSelectedPreviewedNode(node, nodes);
            } else {
                i = this.addDefaultPreviewedNode(node, nodes)
            }
            if (i < 0) {
                break
            }
        }
        return nodes;
    }

    get defaultNode() {
        if (!this.currentNode?.ConnectionsData?.length) {
            return ""
        }
        for (let connection of this.currentNode.ConnectionsData) {
            if (connection.IsDefault) {
                return connection.ConnectedTo
            }
        }
        return this.currentNode.ConnectionsData[0].ConnectedTo
    }

    get defaultPreviewedNode() {
        if (!this.currentPreviewedNode?.ConnectionsData?.length) {
            return ""
        }
        for (let connection of this.currentPreviewedNode.ConnectionsData) {
            if (connection.IsDefault) {
                return connection.ConnectedTo
            }
        }
        return this.currentPreviewedNode.ConnectionsData[0].ConnectedTo
    }

    get averageTime() {
        const sessions = this.currentProcedureSessions;
        if (sessions.length === 0) {
            return "00:00:00"
        }
        let totalTime = 0;
        let sessionsCount = 0;
        for (let session of sessions) {
            if (session.EndTimeStamp) {
                totalTime += new Date(session.EndTimeStamp).valueOf() - new Date(session.StartTimeStamp).valueOf();
                sessionsCount += 1
            }
            // totalTime += (session.EndTimeStamp ? new Date(session.EndTimeStamp) : new Date()).valueOf() - new Date(session.StartTimeStamp).valueOf()
        }
        let averageMillis = Math.ceil((totalTime / sessionsCount));
        // let averageSeconds = Math.ceil((totalTime / sessions.length) / 1000);
        return sharedUtils.renderDisplayTime(averageMillis)
    }

    get completedSessions() {
        const sessions = this.currentProcedureSessions;
        if (sessions.length === 0) {
            return 0
        }
        return sessions.filter(session => session.AbandonedNode === sessionStatusEnum.COMPLETED).length
    }

    get availableNodeLanguages() {
        if (!this.currentProcedure.NestedNodes?.length) {
            return ["ENGLISH_US"];
        }

        const initialNode = this.currentProcedure.NestedNodes[0];

        if (!initialNode || !initialNode.StepHeaderMulti) {
            const defaultLanguage = Object.keys(languageEnum).find(key => languageEnum[key] === this.currentProcedure.DefaultLanguage) || "ENGLISH_US";
            return [defaultLanguage];
        } else {
            const nonDefaultLanguages = Object.keys(languageEnum).filter(key =>
                Object.keys(initialNode.StepHeaderMulti).includes(languageEnum[key]) &&
                languageEnum[key] !== this.currentProcedure.DefaultLanguage
            );

            const defaultLanguage = Object.keys(languageEnum).find(key => languageEnum[key] === this.currentProcedure.DefaultLanguage) || "ENGLISH_US";

            return [defaultLanguage, ...nonDefaultLanguages];
        }
    }

    get availablePreviewedNodeLanguages() {
        return this.getAvailableNodeLanguages(this.currentPreviewedProcedure);
    }

    get languagesVisibility() {
        return this.currentProcedure?.LanguageVisibility;
    }

    changeLanguageVisibility = async (langKey) => {
        this.currentProcedure = await ProcedureRequester.changeLanguageVisibility(this.currentProcedure.ProcedureIdentifier, generalStore.workspace, langKey);
    }
    getAvailableNodeLanguages = procedure => {
        if (!procedure?.NestedNodes?.length) {
            return ["ENGLISH_US"]
        }
        const initialNode = procedure.NestedNodes[0];
        if (!initialNode || !initialNode.StepHeaderMulti) {
            return [Object.keys(languageEnum).find(key => languageEnum[key] === procedure.DefaultLanguage) || "ENGLISH_US"]
        } else return Object.keys(languageEnum).flatMap(key =>
            Object.keys(initialNode.StepHeaderMulti).includes(languageEnum[key])
                ? [key]
                : []
        );
    }

    setMostAbandoned = () => {
        const abandoned = {
            [sessionStatusEnum.NULL]: 0
        };

        let mostAbandoned = sessionStatusEnum.NULL;

        this.currentProcedureSessions.forEach(session => {
            const abandonedId = session.AbandonedNode
            if (!abandoned[abandonedId]) {
                abandoned[abandonedId] = 1
            } else ++abandoned[abandonedId]
            if (
                mostAbandoned === sessionStatusEnum.NULL
                || (
                    abandonedId !== sessionStatusEnum.NULL
                    && abandonedId !== sessionStatusEnum.COMPLETED
                    && abandoned[abandonedId] > abandoned[mostAbandoned]
                )
            ) {
                mostAbandoned = abandonedId;
            }
        })
        const mostNode = this.currentProcedure.NestedNodes?.find(n => n.Identifier === mostAbandoned);
        if (!!mostNode) {
            this.mostAbandoned = mostNode.NodeType === procedureNodeTypeEnum.START ? generalStore.translate('intro') : getProcedureText(mostNode, "StepHeader", this.currentProcedure);
        } else this.mostAbandoned = null
    };

    setCurrentProcedure = async (id, published, workspace) => {
        this.currentIsPublished = published;
        let result;
        if (this.currentIsPublished) {
            result = await ProcedureRequester.getPublishedProcedure(id, workspace)
        } else {
            result = await ProcedureRequester.getProcedure(id, workspace)
        }

        if (result) {
            this.currentProcedure = result;
            const preferredLanguage = generalStore.userDetails?.PreferredLanguage
            if (!!preferredLanguage && this.availableNodeLanguages.map(langKey => languageEnum[langKey]).includes(preferredLanguage)) {
                this.currentProcedure.selectedLanguage = preferredLanguage
            }
            generalStore.isLoaderOpen = false;
            await this.resetProcedure(false);
            return true;
        }
        return false;
    };

    beginSession = async (isPreview = false) => {
        this.resumedSession = false;
        if (!isPreview && this.currentIsPublished && this.recordSession) {
            await this.startRecordedSession(this.currentProcedure.PayPerClickId);
        } else {
            this.currentSession = {
                ProcedureSessionId: uuidv4(),
                Paused: false,
                PauseInstances: [],
                StartTimeStamp: new Date(),
                EndTimeStamp: new Date(),
                // RunIn3D: this.runProcedureIn3D,
                DebrifNodeEntries: [{
                    NodeRef: this.currentNode,
                    NodeStarTime: new Date(),
                    SelectedNodesAtCurrentStep: [...this.selectedNodes],
                }],
                ProjectRef: this.currentProcedure.ProjectRef,
                Docebo: {...this.doceboParams},
                DeviceIdentifier: Cookies.get('deviceId_v2'),
                ViewedLanguage: this.currentProcedure.selectedLanguage,
            };
        }
    }

    checkNoAccess = async (procedure, procedureIsAndProject, db) => {
        if (procedure.IsDeleted || procedure.IsProjectDeleted) {
            return false
        }
        if (procedure.IsPublished) {
            if (procedure.IsProjectPublic || !!procedure.PayPerClickId) {
                return false
            } else if (generalStore.workspace !== db || !generalStore.loggedIn) {
                modalStore.showErrorMessage(generalStore.translate('noProcedureAccessSentence'));
                return true
            }
        }

        const projectId = procedureIsAndProject.includes('~') ? procedureIsAndProject.split('~')[0] : procedure.ProjectRef;

        const status = await ProjectRequester.getProjectPublicityStatus(projectId, db);

        if (generalStore.workspace !== db || !generalStore.loggedIn) {
            modalStore.showErrorMessage(generalStore.translate('noDomainAccessSentence'));
            return true
        } else if (!this.userCanEdit(generalStore.userDetails._id, status)) {
            modalStore.showErrorMessage(generalStore.translate('noAccessSentence'));
            return true
        } else return false
    };

    resetProcedure = async (initial = true) => {
        let result;
        if (initial) {
            if (this.currentIsPublished) {
                result = await ProcedureRequester.getPublishedProcedure(this.currentProcedure.ProcedureIdentifier, generalStore.workspace)
            } else {
                result = await ProcedureRequester.getProcedure(this.currentProcedure.ProcedureIdentifier, generalStore.workspace)
            }
            if (result) {
                this.currentProcedure = result;
            }
        }
        this.headerX = 0;
        this.headerY = 0;
        this.resetInnerProcedures(false);
        this.resetInputValues(this.currentProcedure);
        this.currentStepIndex = 0;
        this.currentNode = this.currentProcedure.NestedNodes.length ? this.currentProcedure.NestedNodes[0] : null;
        this.startNodeSession();
        this.playerHistory = [];
        this.setCurrentMedia(0);
        this.ttsMuted = !this.currentProcedure?.Settings?.AutoTTS;
    };

    getUploadedDigitalTwinStatus = async () => {
        const digitalTwinStatus = this.currentProcedure.UploadStatus;
        if (digitalTwinStatus === uploadStatusEnum.REGULAR) {
            return true;
        }
        if (digitalTwinStatus === uploadStatusEnum.CAD_FILE_PENDING) {
            const result = await ProcedureRequester.getProcedureUploadStatus(this.currentProcedure.ProcedureIdentifier, generalStore.workspace);
            if (result === uploadStatusEnum.CAD_FILE_PENDING) {
                return false;
            }
        }
        await this.setCurrentProcedureStatus();
        return true;
    }

    setCurrentProcedureStatus = async () => {
        const result = await ProcedureRequester.getProcedure(this.currentProcedure.ProcedureIdentifier, generalStore.workspace)
        if (result) {
            this.currentProcedure = result;
        }
    }

    resetInnerProcedures = (isPreview) => {
        this.innerProcedureNextStepIds = [];
        if (this.innerProcedureParentProcedureIds.length) {
            if (isPreview) {
                this.currentPreviewedProcedure = this.fetchedProceduresMap.values().next().value;
                this.currentPreviewedProcedure.NestedNodes.unshift(this.nestedProceduresFirstNode);
            } else {
                this.currentProcedure = this.fetchedProceduresMap.values().next().value;
                this.currentProcedure.NestedNodes.unshift(this.nestedProceduresFirstNode);
            }
        }
        this.innerProcedureParentProcedureIds = [];
        this.innerProcedurePreviousStepsIds = [];
    };

    resetPreviewedProcedure = async () => {
        this.headerX = 0;
        this.headerY = 0;

        this.resetInnerProcedures(true);
        if (!this.sessionViewerOpen) {
            this.resetInputValues(this.currentPreviewedProcedure);
        }
        this.currentPreviewedStepIndex = 0;
        this.currentPreviewedNode = this.currentPreviewedProcedure.NestedNodes[0];
        this.playerHistoryPreview = [];
        this.setCurrentPreviewedMedia(0);

        if (this.sessionViewerOpen) {
            this.ttsMuted = true;
        }
    };

    resetInputValues = procedure => {
        for (let node of procedure.NestedNodes) {
            if (!!node.InputParams) {
                delete node.InputParams.Value
            }
        }
    };

    startNewSession = async (isPreview, initial = false) => {
        if (!isPreview && this.currentHas3D) {
            await this.resetProcedure(initial);
            return
        } else {
            await this.restart2D(isPreview, initial);
        }
        this.currentSession = {
            StartTimeStamp: new Date(),
            DebrifNodeEntries: [],
            PauseInstances: [],
            Docebo: {...this.doceboParams},
            DeviceIdentifier: Cookies.get('deviceId_v2')
        };
        if (this.currentIsPublished && this.recordSession) {
            this.forceNewSession = true;
            await this.startRecordedSession(this.currentProcedure.PayPerClickId);
            // generalStore.preventLeaveActive = true
        }
    };

    setCurrentMedia = (index) => {
        this.currentMedia = this.currentNode && getNodeMedia(this.currentNode, "NodeMediaFilesRefs", this.currentProcedure).FileRefs.length > 0 ? index : -1;
    };

    setCurrentPreviewedMedia = index => {

        this.currentMedia = this.currentPreviewedNode && getNodeMedia(this.currentPreviewedNode, "NodeMediaFilesRefs", this.currentPreviewedProcedure).FileRefs.length > 0 ? index : -1;
    };

    userCanEdit = (userId, status) => {
        if (userId === status.owner) {
            return true
        } else {
            return !!status.collaboratorIds.includes(userId);
        }
    };

    goToPrevious = () => {
        const previousNode = this.findPrevious(this.currentNode.Identifier);
        this.goToNode(previousNode.Identifier);
    };

    goToPreviousPreviewed = () => {
        const previousPreviewedNode = this.findPreviousPreviewed(this.currentPreviewedNode.Identifier);
        this.goToPreviewNode(previousPreviewedNode.Identifier);
    };

    goBackToParentProcedure = async (isPreview) => {
        if (!this.innerProcedurePreviousStepsIds.length) {
            return;
        }
        await this.goToParentProcedure(true, isPreview);
    };

    goNextToParentProcedure = async (isPreview) => {
        if (!this.innerProcedureNextStepIds.length) {
            return;
        }
        await this.goToParentProcedure(false, isPreview);
    };

    goToParentProcedure = async (isBack, isPreview) => {
        const innerProcedureParentProcedureId = this.innerProcedureParentProcedureIds.pop();
        const parentProcedure = this.fetchedProceduresMap.get(innerProcedureParentProcedureId);
        const nextId = this.innerProcedureNextStepIds.pop();
        if (!nextId && !isBack) {
            if (this.innerProcedureParentProcedureIds.length) {
                await this.goToParentProcedure(isBack, isPreview);
            } else {
                if (isPreview) {
                    this.currentPreviewedProcedure = parentProcedure;
                } else {
                    this.currentProcedure = parentProcedure;
                }
                this.endProcedure(isPreview);
            }
            return;
        }

        const prevId = this.innerProcedurePreviousStepsIds.pop();
        const toId = isBack ? prevId : nextId;
        if (!this.innerProcedureParentProcedureIds.length) {
            parentProcedure.NestedNodes.unshift(this.nestedProceduresFirstNode);
        }
        if (isPreview) {
            this.currentPreviewedProcedure = parentProcedure;
            await this.goToPreviewNode(toId);
        } else {
            this.currentProcedure = parentProcedure;
            await this.goToNode(toId);
        }
    }

    getPreviousIndex = (identifier) => {
        let previousNode = this.playerHistory.pop();
        let currentConnections = previousNode.ConnectionsData;
        if (this.getConnectionIndex(identifier, currentConnections) < 0) {
            this.playerHistory.push(previousNode);
            previousNode = this.findPrevious(identifier)
        }
        return this.getNodeIndex(previousNode.Identifier)
    };

    getPreviousPreviewedIndex = (identifier) => {
        let previousNode = this.playerHistoryPreview.pop();
        let currentConnections = previousNode.ConnectionsData;
        if (this.getConnectionIndex(identifier, currentConnections) < 0) {
            this.playerHistoryPreview.push(previousNode);
            previousNode = this.findPreviousPreviewed(identifier)
        }
        return this.getPreviewedNodeIndex(previousNode.Identifier)
    };

    findPrevious = identifier => {
        const nodes = this.selectedNodes;
        for (let i = nodes.length - 1; i > 0; i--) {
            if (this.getConnectionIndex(identifier, nodes[i - 1].ConnectionsData) >= 0) {
                while (nodes[i - 1].NodeType === procedureNodeTypeEnum.OBJECT_DETECTION)
                    i--;
                return nodes[i - 1];
            }
        }
        return nodes[0]
    };

    findPreviousPreviewed = identifier => {
        const nodes = this.selectedPreviewedNodes;
        for (let i = nodes.length - 1; i > 0; i--) {
            if (this.getConnectionIndex(identifier, nodes[i - 1].ConnectionsData) >= 0) {
                while (nodes[i - 1].NodeType === procedureNodeTypeEnum.OBJECT_DETECTION)
                    i--;
                return nodes[i - 1]
            }
        }
        return nodes[0]
    };

    getConnectionIndex = (identifier, connections) => connections.findIndex(c => c.ConnectedTo === identifier);  //gets index in ConnectionsData array of the identifier that matches the query

    restart2D = async (isPreview, initial) => {
        if (isPreview) {
            await this.resetPreviewedProcedure();
            this.goToNextPreviewed(0);
        } else {
            await this.resetProcedure(initial);
            if (this.currentNode?.ConnectionsData?.[0]) {
                this.goToNext(0);
            }
        }
    }

    goToNext = connectionIndex => {
        this.goToNode(this.currentNode.ConnectionsData[connectionIndex].ConnectedTo);
    };

    goToNextPreviewed = connectionIndex => {
        this.goToPreviewNode(this.currentPreviewedNode.ConnectionsData[connectionIndex].ConnectedTo);
    };

    getNodeIndex = identifier => {
        return this.currentProcedure.NestedNodes.findIndex(n => n.Identifier === identifier);
    }

    getPreviewedNodeIndex = identifier => {
        return this.currentPreviewedProcedure.NestedNodes.findIndex(n => n.Identifier === identifier);
    }

    goToNode = async (identifier, procedureInProcedureName = null) => {
        this.endNodeSession();
        this.playerHistory.push(this.currentNode);
        let index = this.getNodeIndex(identifier);
        this.currentStepIndex = index >= 0 ? index : this.currentStepIndex;  //in case the guide has a connection reference that does not exist
        if (index === 0 && this.innerProcedureParentProcedureIds.length) {
            this.currentStepIndex = 0;
        }
        this.currentNode = this.currentProcedure.NestedNodes[this.currentStepIndex];
        this.currentNode.userSelection = null;
        if (this.currentNode.NodeType === procedureNodeTypeEnum.INNER_PROCEDURE) {
            await this.goToInnerProcedure();
            return;
        }

        if (this.currentNode.NodeType === procedureNodeTypeEnum.END) {
            this.endProcedure();
            return
        }

        if (!!this.currentNode.Style?.FloatDefaultPosition) {
            this.headerX = this.currentNode.Style.FloatDefaultPosition.HeaderX || 0;
            this.headerY = this.currentNode.Style.FloatDefaultPosition.HeaderY || 0;
        } else {
            this.headerX = 0;
            this.headerY = 0;
        }

        this.startNodeSession(procedureInProcedureName);
        this.updateSession(this.currentProcedure.IsPublished); // checks is recording inside
        this.setCurrentMedia(0);
        this.escapeAndSpeakDescription(false);
    };

    escapeAndSpeakDescription = (isPreview) => {
        if (this.ttsMuted) {
            return;
        }

        this.stopTTS();
        const currentNode = isPreview ? this.currentPreviewedNode : this.currentNode;
        const currentProcedure = isPreview ? this.currentPreviewedProcedure : this.currentProcedure;

        let htmlText;
        if (currentNode.WarningPopupIdentifiers && currentNode.WarningPopupIdentifiers.length) {
            let warningPopup;
            for (const nodeId of currentNode.WarningPopupIdentifiers) {
                const popupNode = this.getNodeById(nodeId, isPreview);
                if (!popupNode) {
                    continue;
                }
                if (!popupNode.approved) {
                    warningPopup = popupNode;
                    const textKey = warningPopup.CustomTextToSpeechActive ? "CustomTextToSpeech" : "StepText";
                    htmlText = getProcedureText(warningPopup, textKey, currentProcedure);

                    if (!htmlText) {
                        return;
                    }
                    break;
                }
            }
        }
        if (!htmlText) {
            const textKey = currentNode.CustomTextToSpeechActive ? "CustomTextToSpeech" : "StepText";
            htmlText = getProcedureText(currentNode, textKey, currentProcedure);
        }
        if (!htmlText) {
            return;
        }
        const textWithoutSpans = htmlText.split(/<span.*?>/).join('').split('</span>').join(',');
        const textWithoutOtherTags = textWithoutSpans.split(/<.*?>/).join('').split(/<\/.*?>/).join('.');
        const textWithoutNbsp = textWithoutOtherTags.split('&nbsp;').join(' ')

        const selectedLanguage = currentProcedure?.selectedLanguage || currentProcedure?.DefaultLanguage || languageEnum.ENGLISH_US;
        this.speak(textWithoutNbsp, selectedLanguage, currentProcedure.ProcedureIdentifier).then();
    }

    speak = async (text, language, procedureId) => {
        if (!this.ttsToken || Date.now() > this.ttsTokenExpiration) {
            const {
                token,
                expiration,
                region
            } = await ProcedureRequester.getTtsToken(procedureId, generalStore.workspace);
            this.ttsToken = token;
            this.ttsTokenExpiration = expiration;
            this.ttsRegion = region;
        }
        const speechConfig = SpeechConfig.fromAuthorizationToken(this.ttsToken, this.ttsRegion);

        const languageParts = language.split('-');
        const langPart = languageParts[0].toLowerCase()
            .replace('cn', 'zh')
            .replace('jp', 'ja')
            .replace('kr', 'ko');

        const countryPart = languageParts[1] || languageParts[0];
        const ttsLanguage = langPart + '-' + countryPart;
        const voice = ttsLanguagesEnum[ttsLanguage];

        speechConfig.speechSynthesisLanguage = ttsLanguage;
        speechConfig.speechSynthesisVoiceName = voice;
        const mainLanguageForSSML = voice.slice(0, 5);
        this.ttsPlayer = new SpeakerAudioDestination();
        this.ttsPlayer.onAudioEnd = () => {
            console.log("Finished speaking");
        };
        const audioConfig = AudioConfig.fromSpeakerOutput(this.ttsPlayer);
        const speechSynthesizer = new SpeechSynthesizer(speechConfig, audioConfig);

        const finalText = Utility.removeHtmlSpecialChars(text).replace('&', ' ampersand ');

        this.speakTTSLoop(speechSynthesizer, finalText, mainLanguageForSSML, voice, ttsLanguage);

    }

    speakTTSLoop(speechSynthesizer, finalText, mainLanguageForSSML, voice, ttsLanguage) {
        let textLater = finalText, currentText;
        this.speakingInterval = setInterval(async () => {
            if (!textLater) {
                clearInterval(this.speakingInterval);
                return;
            }
            if (textLater.length > 200) {
                let cutIndex;
                for (const separator of ['\n', '.', ' ']) {
                    cutIndex = textLater.substr(0, 200).lastIndexOf(separator);
                    if (cutIndex !== -1) {
                        break;
                    }
                }
                currentText = textLater.substr(0, cutIndex);
                textLater = textLater.substr(cutIndex + 1);
            } else {
                currentText = textLater;
                textLater = '';
            }
            // noinspection XmlUnusedNamespaceDeclaration
            await new Promise((resolve, reject) => speechSynthesizer.speakSsmlAsync(
                `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="${mainLanguageForSSML}">` +
                `<voice name="${voice}">` +
                `<lang xml:lang="${ttsLanguage}">${currentText}</lang>` +
                '</voice>' +
                '</speak>',
                result => {
                    if (!result || result?.errorDetails) {
                        reject(result?.errorDetails);
                    } else {
                        resolve();
                    }
                }, reject)).catch(e => {
                console.error('could not tts', e)
            });


        }, 100);


    }

    stopTTS = () => {
        if (!this.ttsPlayer) {
            return;
        }
        this.ttsPlayer.pause();
        this.ttsPlayer.close();
    }
    jumpToAncestorProcedure = async (index, isPreview) => {
        let nextProcedureId;
        do {
            nextProcedureId = this.innerProcedureParentProcedureIds.pop();
            this.innerProcedureNextStepIds.pop();
            this.innerProcedurePreviousStepsIds.pop();
        } while (this.innerProcedureParentProcedureIds.length !== index);
        if (isPreview) {
            this.currentPreviewedProcedure = this.fetchedProceduresMap.get(nextProcedureId);
            await this.goToPreviewNode();

        } else {
            this.currentProcedure = this.fetchedProceduresMap.get(nextProcedureId);
            await this.goToNode();
        }
    }

    goToInnerProcedure = async () => {
        try {
            generalStore.isLoaderOpen = true;

            if (!this.fetchedProceduresMap.size) {
                this.nestedProceduresFirstNode = this.currentProcedure.NestedNodes[0];
            }
            if (!this.fetchedProceduresMap.has(this.currentProcedure.ProcedureIdentifier)) {
                this.fetchedProceduresMap.set(this.currentProcedure.ProcedureIdentifier, this.currentProcedure);
            }
            const nextStepId = this.currentNode.ConnectionsData && this.currentNode.ConnectionsData[0].ConnectedTo;
            const previousStep = this.findPrevious(this.currentNode.Identifier);
            const previousStepId = previousStep && previousStep.Identifier;
            let innerProcedure = this.fetchedProceduresMap.get(this.currentNode.InnerProcedureRef);
            if (!innerProcedure) {
                if (this.currentProcedure.importedFromWorkspace) {
                    innerProcedure = this.getProcedureFromDataStore(this.projectStore.currentProject?.ProjectIdentifier, this.currentNode.InnerProcedureRef);
                } else {
                    innerProcedure = await ProcedureRequester.getPublishedProcedure(this.currentNode.InnerProcedureRef, generalStore.workspace);
                }
                this.fetchedProceduresMap.set(innerProcedure.ProcedureIdentifier, innerProcedure);
            }
            this.innerProcedureNextStepIds.push(nextStepId);
            this.innerProcedureParentProcedureIds.push(this.currentProcedure.ProcedureIdentifier);
            previousStepId && this.innerProcedurePreviousStepsIds.push(previousStepId);
            let nodes = [...innerProcedure.NestedNodes];
            if (nodes[0].NodeType === procedureNodeTypeEnum.START && nodes[0].ConnectionsData[0]) {
                const realStartId = nodes[0].ConnectionsData[0].ConnectedTo;
                // noinspection UnnecessaryLocalVariableJS
                const newStartNode = nodes.filter(node => node.Identifier === realStartId)[0];
                if (newStartNode) {
                    nodes[0] = newStartNode;
                }
                innerProcedure.NestedNodes = [...nodes];
            }
            this.currentProcedure = innerProcedure;
            this.currentStepIndex = 0;
            await this.goToNode(innerProcedure.NestedNodes[0].Identifier, innerProcedure.ProcedureName);
        } catch (e) {
            console.error(e);
            this.currentNode.notAllowed = true;
            this.currentNode = editProcedureText("", this.currentNode, "StepHeader", this.currentProcedure);
            this.currentNode = editProcedureText("", this.currentNode, "StepText", this.currentProcedure);
        }

        generalStore.isLoaderOpen = false;
    }

    goToInnerPreviewProcedure = async () => {
        try {
            generalStore.isLoaderOpen = true;

            if (!this.fetchedProceduresMap.size) {
                this.nestedProceduresFirstNode = this.currentPreviewedProcedure.NestedNodes[0];
            }
            if (!this.fetchedProceduresMap.has(this.currentPreviewedProcedure.ProcedureIdentifier)) {
                this.fetchedProceduresMap.set(this.currentPreviewedProcedure.ProcedureIdentifier, this.currentPreviewedProcedure);
            }
            const nextStepId = this.currentPreviewedNode.ConnectionsData && this.currentPreviewedNode.ConnectionsData[0].ConnectedTo;
            const previousStep = this.findPreviousPreviewed(this.currentPreviewedNode.Identifier);
            const previousStepId = previousStep && previousStep.Identifier;
            let innerProcedure = this.fetchedProceduresMap.get(this.currentPreviewedNode.InnerProcedureRef);
            if (!innerProcedure) {
                innerProcedure = await ProcedureRequester.getPublishedProcedure(this.currentPreviewedNode.InnerProcedureRef, generalStore.workspace);
                this.fetchedProceduresMap.set(innerProcedure.ProcedureIdentifier, innerProcedure);
            }
            this.innerProcedureNextStepIds.push(nextStepId);
            this.innerProcedureParentProcedureIds.push(this.currentPreviewedProcedure.ProcedureIdentifier);
            previousStepId && this.innerProcedurePreviousStepsIds.push(previousStepId);
            let nodes = [...innerProcedure.NestedNodes];
            if (nodes[0].NodeType === procedureNodeTypeEnum.START && nodes[0].ConnectionsData[0]) {
                const realStartId = nodes[0].ConnectionsData[0].ConnectedTo;
                // noinspection UnnecessaryLocalVariableJS
                const newStartNode = nodes.filter(node => node.Identifier === realStartId)[0];
                if (newStartNode) {
                    nodes[0] = newStartNode;
                }
                innerProcedure.NestedNodes = [...nodes];
            }
            this.currentPreviewedProcedure = innerProcedure;
            this.currentStepIndex = 0;
            await this.goToPreviewNode(innerProcedure.NestedNodes[0].Identifier);
        } catch (e) {
            this.currentPreviewedNode.notAllowed = true;
            this.currentPreviewedNode = editProcedureText("", this.currentPreviewedNode, "StepHeader", this.currentPreviewedProcedure);
            this.currentPreviewedNode = editProcedureText("", this.currentPreviewedNode, "StepText", this.currentPreviewedProcedure);
        }

        generalStore.isLoaderOpen = false;
    }

    goToPreviewNode = async identifier => {
        const allNodes = this.currentPreviewedProcedure.NestedNodes;
        const possibleAttachedNode = allNodes.filter(node => {
            return node.WarningPopupIdentifiers && node.WarningPopupIdentifiers.filter(popupId => popupId === identifier).length;
        });
        if (possibleAttachedNode.length === 1) {
            identifier = possibleAttachedNode[0].Identifier;
        }
        this.playerHistoryPreview.push(this.currentPreviewedNode);
        let index = this.getPreviewedNodeIndex(identifier);
        this.currentPreviewedStepIndex = index >= 0 ? index : this.currentPreviewedStepIndex;  //in case the guide has a connection reference that does not exist
        this.currentPreviewedNode = this.currentPreviewedProcedure.NestedNodes[this.currentPreviewedStepIndex];

        if (!!this.currentPreviewedNode.Style?.FloatDefaultPosition) {
            this.headerX = this.currentPreviewedNode.Style.FloatDefaultPosition.HeaderX || 0;
            this.headerY = this.currentPreviewedNode.Style.FloatDefaultPosition.HeaderY || 0;
        } else {
            this.headerX = 0;
            this.headerY = 0;
        }

        if (this.currentPreviewedNode.NodeType === procedureNodeTypeEnum.INNER_PROCEDURE) {
            await this.goToInnerPreviewProcedure();
            return;
        }
        this.setCurrentPreviewedMedia(0);
        this.escapeAndSpeakDescription(true);
    };

    addUserSelection = (identifier, index, connectionName) => {
        this.currentNode.userSelection = identifier;
        this.currentNode.userSelectionIndex = index;
        const currentNode = this.currentSession.DebrifNodeEntries.pop();
        if (!currentNode.NodeSubEvents) {
            currentNode.NodeSubEvents = [];
        }
        currentNode.NodeSubEvents.push({
            SubEventText: `selected - ${connectionName}`,
            SubEventTime: new Date(),
            IsError: false,
            SelectedNode: identifier,
        })
        currentNode.SelectedNode = identifier
        this.currentSession.DebrifNodeEntries.push(currentNode);
        this.goNextBySelection(index, false);
    };

    addUserPreviewedSelection = (identifier, index) => {
        this.currentPreviewedNode.userSelection = identifier;
        this.currentPreviewedNode.userSelectionIndex = index;
        this.goNextBySelection(index, true);
    };

    goNextBySelection = (index, isPreview) => {
        const currentProcedure = isPreview ? this.currentPreviewedProcedure : this.currentProcedure;
        const clickToSelect = currentProcedure?.Settings?.ClickToSelect;
        if (!clickToSelect) {
            return;
        }
        const currentNode = isPreview ? this.currentPreviewedNode : this.currentNode;

        const nextStepAvailable = isPreview ? this.nextPreviewedStepAvailable : this.nextStepAvailable;
        if (!nextStepAvailable) { // PinP
            if (this.innerProcedureNextStepIds.length) {
                this.goNextToParentProcedure(isPreview);
            }
            return;
        }

        if (!currentNode.ConnectionsData[index].ConnectedTo) { // End
            this.endProcedure(isPreview);
            return;
        }
        const goToMethod = isPreview ? this.goToNextPreviewed : this.goToNext;
        goToMethod(index);
    };

    addNextNode = (identifier, array) => {
        let index = this.getNodeIndex(identifier);
        if (index >= 0) {
            if (this.checkNodeAlreadyPresent(identifier, array)) {
                return -1
            }
            array.push(this.currentProcedure.NestedNodes[index])
        }
        return index
    };

    addNextPreviewedNode = (identifier, array) => {
        let index = this.getPreviewedNodeIndex(identifier);
        if (index >= 0) {
            if (this.checkNodeAlreadyPresent(identifier, array)) {
                return -1
            }
            array.push(this.currentPreviewedProcedure.NestedNodes[index])
        }
        return index
    };

    addDefaultNode = (node, array) => {
        if (node.ConnectionsData.length <= 1) {
            return this.addNextNode(node.ConnectionsData[0].ConnectedTo, array)
        } else {
            for (let connection of node.ConnectionsData) {
                if (connection.IsDefault) {
                    if (this.checkNodeAlreadyPresent(connection.ConnectedTo, array)) {   //to avoid endless loops
                        return -1
                    } else return this.addNextNode(connection.ConnectedTo, array)
                }
            }
            return this.addNextNode(node.ConnectionsData[0].ConnectedTo, array)
        }
    };

    addDefaultPreviewedNode = (node, array) => {
        if (node.ConnectionsData.length <= 1) {
            return this.addNextPreviewedNode(node.ConnectionsData[0].ConnectedTo, array)
        } else {
            for (let connection of node.ConnectionsData) {
                if (connection.IsDefault) {
                    if (this.checkNodeAlreadyPresent(connection.ConnectedTo, array)) {   //to avoid endless loops
                        return -1
                    } else return this.addNextPreviewedNode(connection.ConnectedTo, array)
                }
            }
            return this.addNextPreviewedNode(node.ConnectionsData[0].ConnectedTo, array)
        }
    };

    addSelectedNode = (node, array) => {
        let index = this.getNodeIndex(node.userSelection);
        if (index >= 0) {
            if (this.checkNodeAlreadyPresent(node.userSelection, array)) {   //to avoid endless loops
                return this.addDefaultNode(node, array)
            } else {
                array.push(this.currentProcedure.NestedNodes[index]);
                return index
            }
        }
    };

    addSelectedPreviewedNode = (node, array) => {
        let index = this.getPreviewedNodeIndex(node.userSelection);
        if (index >= 0) {
            if (this.checkNodeAlreadyPresent(node.userSelection, array)) {   //to avoid endless loops
                return this.addDefaultPreviewedNode(node, array)
            } else {
                array.push(this.currentPreviewedProcedure.NestedNodes[index]);
                return index
            }
        }
    };

    checkNodeAlreadyPresent = (identifier, array) => {
        const node1 = array.find(n => n.Identifier === identifier);
        return node1 !== undefined
    };

    updateProcedureSession = async(session, workspace) => {
        const sessionData = session ?? this.currentSession;
        const isCompletion = sessionData.AbandonedNode === sessionStatusEnum.COMPLETED;
        if (isCompletion || !this.isUpdatingProcedureSessionLoading) {
            this.isUpdatingProcedureSessionLoading = true;
            await ProcedureRequester.updateSession(sessionData, workspace ?? generalStore.workspace);
            this.isUpdatingProcedureSessionLoading = false;
        }
    }

    endProcedure = isPreview => {
        this.shutUp();
        if (this.sessionViewerOpen) {
            return
        }

        const endNode = {    //TODO possible change to set this to pre-designed end node from editor
            NodeType: procedureNodeTypeEnum.END,
            Identifier: "procedure-end",
            StepHeader: generalStore.translate('end')
        }

        if (isPreview) {
            this.playerHistory.push(this.currentPreviewedNode);
            this.currentPreviewedNode = endNode;
        } else {
            this.playerHistory.push(this.currentNode);
            this.currentNode = endNode;
        }
        this.endNodeSession();
        this.currentSession.AbandonedNode = sessionStatusEnum.COMPLETED;
        if (this.currentSession.Paused) {
            const pauseIndex = this.currentSession.PauseInstances.length - 1;
            this.currentSession.PauseInstances[pauseIndex].PauseEnd = new Date();
            this.currentSession.Paused = false;
        }
        this.currentSession.PausedState = null;
        // this.updateSession(this.currentProcedure.IsPublished)
        this.currentSession.EndTimeStamp = new Date();
        if (this.currentProcedure.IsPublished === true && this.recordSession) {
            this.updateProcedureSession().then();
        }
        clearInterval(this.updaterInterval);
        this.updaterInterval = null;
        this.currentNode = endNode;
        this.clearWarningAcknowledgements(isPreview);
        if (!isPreview) {
            const user = generalStore.userDetails;
            const workspace = generalStore.workspace;
            const userDomainSettings = generalStore.userCurrentDomainSettings;
            if (!!userDomainSettings && !!userDomainSettings.ActiveSessions) {
                delete userDomainSettings.ActiveSessions[this.currentProcedure.ProcedureIdentifier];
                user.Domains[workspace] = userDomainSettings;
                generalStore.updateUser(user).then();
            }
        }
        generalStore.preventLeaveActive = false;
    };

    clearWarningAcknowledgements = isPreview => {
        const procedure = isPreview ? this.currentPreviewedProcedure : this.currentProcedure;
        procedure.NestedNodes.forEach(node => delete node.approved)
    };

    setNewSession = (user, userName, userDomainSettings, workspace, payPerClickId = null) => {
        const sessionId = uuidv4();
        this.currentSession = {
            ProcedureSessionId: sessionId,
            Paused: false,
            PausedState: {
                currentNode: this.currentNode,
                currentStepIndex: this.currentStepIndex,
                currentMedia: this.currentMedia,
                playerHistory: this.playerHistory,
                volume: this.volume,
                mute: this.mute,
                headerX: this.headerX,
                headerY: this.headerY,
            },
            PauseInstances: [],
            StartTimeStamp: new Date(),
            EndTimeStamp: new Date(),
            AbandonedNode: this.currentNode ? this.currentNode.Identifier : sessionStatusEnum.NULL,
            // RunIn3D: this.runProcedureIn3D,
            DebrifNodeEntries: [{
                NodeRef: this.currentNode,
                NodeStarTime: new Date(),
                SelectedNodesAtCurrentStep: [...this.selectedNodes],
            }],
            ProjectRef: this.projectStore.currentProject?.ProjectIdentifier, // might be mirrored
            UserName: payPerClickId ? generalStore.translate('guest') : userName,
            ProcedureName: this.currentProcedure.ProcedureName,
            ProcedureRef: this.currentProcedure.ProcedureIdentifier,
            OriginalProcedure: JSON.stringify(this.currentProcedure),
            UserId: user._id,
            Device: 'Web', // TODO enum,
            ProcedureType: this.currentProcedure.ProcedureType,
            MediaProcedureFile: this.currentProcedure.MediaProcedureFile,
            ThreeDFilesAndroid: this.currentProcedure.ThreeDFilesAndroid,
            ThreeDFilesHololens: this.currentProcedure.ThreeDFilesHololens,
            ThreeDFilesIOs: this.currentProcedure.ThreeDFilesIOs,
            ThreeDFilesWebgl: this.currentProcedure.ThreeDFilesWebgl,
            ThreeDFilesWin: this.currentProcedure.ThreeDFilesWin,
            ThreeDFilesOsx: this.currentProcedure.ThreeDFilesOsx,
            PayPerClickId: payPerClickId,
            Docebo: {...this.doceboParams},
            DeviceIdentifier: Cookies.get('deviceId_v2'),
            ViewedLanguage: this.currentProcedure.selectedLanguage,
            DefaultLanguage: this.currentProcedure.DefaultLanguage,
        };
        if (!!userDomainSettings && this.currentProcedure.ProcedureType === procedureTypeEnum.REGULAR) {
            if (!userDomainSettings.ActiveSessions) {
                userDomainSettings.ActiveSessions = {};
            }
            userDomainSettings.ActiveSessions[this.currentProcedure.ProcedureIdentifier] = this.currentSession.ProcedureSessionId;
            user.Domains[workspace] = userDomainSettings;
        }
    }

    startRecordedSession = async (payPerClickId = null) => {
        const startOver = this.forceNewSession;

        if (!this.updaterInterval) {
            this.updaterInterval = setInterval(this.updateSession, ONE_MINUTE)
        }

        if ([procedureTypeEnum.FUSION, procedureTypeEnum.SITE_PREP, procedureTypeEnum.VIRTUAL_CLASS_ROOM, procedureTypeEnum.VIRTUAL_ROOM].includes(this.currentProcedure.ProcedureType)) {
            return;
        }

        const user = generalStore.userDetails;
        const workspace = generalStore.workspace;
        const userName = user.Name + ' ' + user.LastName;
        const procedureRef = this.currentProcedure.ProcedureIdentifier;
        const deviceId = Cookies.get('deviceId_v2');
        const userDomainSettings = generalStore.userCurrentDomainSettings;
        let existingPayPerClickSession;

        if (!!payPerClickId && !!deviceId) {
            existingPayPerClickSession = await ProcedureRequester.getPayPerClickSession(workspace, procedureRef, payPerClickId);
        }

        const resumeExistingSession = !startOver && (!!userDomainSettings?.ActiveSessions?.[procedureRef] || !!existingPayPerClickSession)
        if (!!resumeExistingSession) {
            let session;
            if (!!existingPayPerClickSession) {
                session = existingPayPerClickSession;
            } else {
                const sessionId = userDomainSettings.ActiveSessions[procedureRef];
                session = await ProcedureRequester.getProcedureSession(workspace, sessionId);
            }
            if (!session) {  //to catch error of no session returned from db
                this.setNewSession(user, userName, userDomainSettings, workspace, payPerClickId);
            } else {
                if (session.AbandonedNode === sessionStatusEnum.COMPLETED || (this.currentProcedure.ProcedureType !== procedureTypeEnum.REGULAR) /*|| !!this.runProcedureIn3D || !!session.RunIn3D*/) {
                    session.AbandonedNode = sessionStatusEnum.COMPLETED;    //session EndTimeStamp will remain the last recorded time
                    this.updateProcedureSession(session, workspace).then();
                    if (!!userDomainSettings && !payPerClickId) {  //only update if signed-in user, not guest using payPerClick
                        delete userDomainSettings.ActiveSessions[this.currentProcedure.ProcedureIdentifier];
                        user.Domains[workspace] = userDomainSettings;
                        generalStore.updateUser(user).then();
                    }

                    this.setNewSession(user, userName, userDomainSettings, workspace, payPerClickId);
                } else {
                    this.currentSession = session;
                    if (!session.Paused) {
                        this.currentSession.Paused = true;
                        this.createPauseInstance(session.EndTimeStamp);
                    }
                    if (!!session.PausedState && session.PausedState.currentStepIndex != null) {
                        this.currentStepIndex = session.PausedState.currentStepIndex;
                        this.currentNode = this.currentProcedure.NestedNodes[this.currentStepIndex];
                        this.currentMedia = session.PausedState.currentMedia;
                        this.playerHistory = session.PausedState.playerHistory;
                        this.volume = session.PausedState.volume;
                        this.mute = session.PausedState.mute;
                        this.headerX = session.PausedState.headerX;
                        this.headerY = session.PausedState.headerY;
                    }
                    this.resumedSession = true;
                }
            }
        } else {
            this.setNewSession(user, userName, userDomainSettings, workspace, payPerClickId);
        }
        const taskRef = Cookies.get(GeneralStore.TASK_REF_COOKIE_NAME);
        if (taskRef) {
            this.currentSession.TaskRef = taskRef;
            this.currentSession.SessionType = 'related to task'; // TODO enum
            Cookies.remove(GeneralStore.TASK_REF_COOKIE_NAME);
        }
        if (this.recordSession) {
            await this.updateProcedureSession(this.currentSession, workspace)
        }
        generalStore.preventLeaveActive = true;
    };

    updateSession = () => {
        const published = this.currentProcedure.IsPublished;
        if (!this.currentSession.ProcedureSessionId) {   //so that updater only updates active sessions, not on starting screens
            return
        }

        if ([procedureTypeEnum.FUSION, procedureTypeEnum.SITE_PREP, procedureTypeEnum.VIRTUAL_CLASS_ROOM, procedureTypeEnum.VIRTUAL_ROOM].includes(this.currentProcedure.ProcedureType)) {
            return;
        }

        if (this.currentSession.Paused || !this.currentSession.DebrifNodeEntries) {
            return;
        }

        if ((this.currentProcedure.ProcedureType === procedureTypeEnum.REGULAR) && !this.runProcedureIn3D) {     //only add pause to updates if it is a regular procedure
            const currentSessionNode = this.currentSession.DebrifNodeEntries[this.currentSession.DebrifNodeEntries.length - 1];
            let autoPause = 1000 * 60 * 60 * 2;

            //TODO for testing
            const userDomainSettings = generalStore.userCurrentDomainSettings;
            if (!!userDomainSettings && !!userDomainSettings.DefaultAutoPause) {
                autoPause = userDomainSettings.DefaultAutoPause * 1000
            }
            //TODO end for testing

            if (Date.now() - new Date(currentSessionNode.NodeStarTime).valueOf() > autoPause) {
                this.currentSession.Paused = true;
                this.createPauseInstance();
            }
            this.currentSession.PausedState = {
                currentNode: this.currentNode,
                currentStepIndex: this.currentStepIndex,
                currentMedia: this.currentMedia,
                playerHistory: this.playerHistory,
                volume: this.volume,
                mute: this.mute,
                headerX: this.headerX,
                headerY: this.headerY,
            }
        }

        this.currentSession.EndTimeStamp = new Date();
        if (published === true && this.recordSession) {
            this.updateProcedureSession().then();
        }
    };

    togglePauseProcedure = isPreview => {
        if (isPreview) {
            return
        }
        if (!this.currentSession.Paused) {
            this.createPauseInstance()
        } else {
            if (!!this.currentSession.PauseInstances && this.currentSession.PauseInstances.length > 0) {
                const pauseIndex = this.currentSession.PauseInstances.length - 1;
                this.currentSession.PauseInstances[pauseIndex].PauseEnd = new Date();
            }
        }
        this.currentSession.EndTimeStamp = new Date();
        this.currentSession.Paused = !this.currentSession.Paused;
        if (this.currentProcedure.IsPublished === true && this.recordSession) {
            this.updateProcedureSession().then();
        }
        generalStore.preventLeaveActive = this.currentSession.Paused;
        if (this.currentSession.Paused) {
            this.shutUp();
        } else {
            this.escapeAndSpeakDescription(isPreview);
        }
    };

    createPauseInstance = (date = null) => {
        const newPauseInstance = {
            PauseStart: date ? new Date(date) : new Date(),
            NodeEntryIndex: this.currentSession.DebrifNodeEntries.length - 1
        }
        if (!this.currentSession.PauseInstances) {
            this.currentSession.PauseInstances = [newPauseInstance]
        } else this.currentSession.PauseInstances.push(newPauseInstance)
    };

    startNodeSession = (procedureInProcedureName = null) => {
        this.currentSession.AbandonedNode = this.currentNode ? this.currentNode.Identifier : sessionStatusEnum.NULL;
        const sessionNode = {
            NodeRef: this.currentNode,
            NodeStarTime: new Date(),
            SelectedNodesAtCurrentStep: [...this.selectedNodes],
        };

        if (procedureInProcedureName) {
            sessionNode.ProcedureInProcedureName = procedureInProcedureName;
        }
        this.currentSession.DebrifNodeEntries.push(sessionNode)
    };


    editNodeSessionInput = (originalParams, value) => {
        this.currentSession.DebrifNodeEntries[this.currentSession.DebrifNodeEntries.length - 1].InputParams = {
            Type: originalParams.Type,
            DefaultValue: originalParams.DefaultValue,
            Value: value,
            InputTime: new Date()
        };
        this.currentNode.InputParams.Value = value;
    };

    addWarningAcknowledgementToSession = (title) => {
        const currentSessionNode = this.currentSession.DebrifNodeEntries[this.currentSession.DebrifNodeEntries.length - 1];
        if (!currentSessionNode.NodeSubEvents) {
            currentSessionNode.NodeSubEvents = [];
        }
        const strippedHtmlTitle = title.split(/<.*?>/).join('');
        currentSessionNode.NodeSubEvents.push({
            SubEventText: `User acknowledged warning "${strippedHtmlTitle}"`,
            SubEventTime: new Date(),
            IsError: false,
            MediaIndex: this.currentMedia
        });
    };

    endNodeSession = () => {
        if (!this.currentSession?.DebrifNodeEntries.length) {
            return
        }
        this.currentSession.DebrifNodeEntries[this.currentSession.DebrifNodeEntries.length - 1].NodeEndTime = new Date()
    };

    getLastEdit = async () => {
        const procedure = this.currentProcedure;
        const procedureId = procedure?.ProcedureIdentifier;
        const user = await generalStore.getUserName(procedure.LastUpdateBy);
        if (this.currentProcedure?.ProcedureIdentifier !== procedureId) return;
        this.lastEdits.date = new Date(Number(procedure.LastUpdate));
        this.lastEdits.user = user;
    };

    publishProcedure = async (versionObj, payPerClick) => await ProcedureRequester.publishProcedure(this.currentProcedure.ProcedureIdentifier, versionObj, generalStore.workspace, payPerClick);
    unPublishProcedure = async () => {
        await ProcedureRequester.unPublishProcedure(this.currentProcedure.ProcedureIdentifier, generalStore.workspace);
        await this.getProcedureVersions();
        this.currentProcedure.CurrentVersion = null;
    }

    sendSitePrepPublishRequest = async () => await ProcedureRequester.sendSitePrepPublishRequest(this.currentProcedure.ProcedureIdentifier, generalStore.workspace);

    deleteProcedure = async (procedure) => await ProcedureRequester.deleteProcedure(procedure.ProcedureIdentifier, generalStore.workspace);

    saveDashboardEdits = async (name, description, AIInstructions, procedureId,) => {
        const procedureJson = {
            ProcedureIdentifier: procedureId,
            ProcedureName: name,
            ProcedureDescription: description,
            AIInstructions: AIInstructions,
        };
        return await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
    };

    updateSitePrepDetails = async (procedureId, sitePrepData) => {
        const procedureJson = {
            ProcedureIdentifier: procedureId,
            ...sitePrepData
        };
        return await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
    }

    savePlayerSettings = async (settings, procedureId) => {
        const procedureJson = {
            ProcedureIdentifier: procedureId,
            Settings: settings
        };
        return await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
    };

    saveThreeDSettings = async (settings, procedureId) => {
        const procedureJson = {
            ProcedureIdentifier: procedureId,
            ThreeDSettings: settings
        };
        return await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
    };

    addProcedureThumbnail = async (procedureId, imageId, thumbId) => {
        const procedureJson = {
            ProcedureIdentifier: procedureId,
            coverImg: imageId,
            coverImgThumb: thumbId
        };
        // noinspection UnnecessaryLocalVariableJS
        const savedProcedure = await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
        return savedProcedure
    };

    replaceProcedureMedia = async (file) => {
        const procedureJson = {
            ProcedureIdentifier: this.currentProcedure.ProcedureIdentifier,
            MediaProcedureFile: file
        };
        const savedProcedure = await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
        this.currentProcedure.MediaProcedureFile = file;
        return savedProcedure;
    };

    replaceProcedureLink = async (link) => {
        const procedureJson = {
            ProcedureIdentifier: this.currentProcedure.ProcedureIdentifier,
            ProcedureLink: link
        };
        const savedProcedure = await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
        this.currentProcedure.ProcedureLink = link;
        return savedProcedure;
    };

    getProcedureViews = async (db = generalStore.workspace) => {
        this.procedureViews = await this.getAllViews(this.currentProcedure.ProcedureIdentifier, db);
        this.currentProcedure = await ProcedureRequester.getProcedure(this.currentProcedure.ProcedureIdentifier, generalStore.workspace);
    }

    getAllViews = async (procedureId, db) => await ProcedureRequester.getAllViews(procedureId, db);     //TODO this will need to be a saved value in the document that is updated at regular intervals, rather than continuously live

    deleteProcedureLanguage = async (langKey) => {
        this.currentProcedure = await ProcedureRequester.deleteProcedureLanguage(generalStore.workspace, this.currentProcedure.ProcedureIdentifier, langKey);
        editorStore.nodes.forEach(node => {
            if (node?.data?.nodeData?.StepHeaderMulti) {
                delete node.data.nodeData.StepHeaderMulti[langKey];
            }
            if (node?.data?.nodeData?.StepTextMulti) {
                delete node.data.nodeData.StepTextMulti[langKey];
            }
            if (node?.data?.nodeData?.ConfirmationTextMulti) {
                delete node.data.nodeData.ConfirmationTextMulti[langKey];
            }
            if (node?.data?.nodeData?.ConnectionsData) {
                node.data.nodeData.ConnectionsData.forEach(connection => {
                    if (connection?.ConnectionNameMulti) {
                        delete connection.ConnectionNameMulti[langKey];
                    }
                })
            }
        });
        this.getAvailableNodeLanguages(this.currentProcedure);
    }

    getProcedureSessions = async procedureId => {
        this.areSessionsLoaded = false;
        const response = await ProcedureRequester.getSessions(procedureId, generalStore.workspace);
        if (this.currentProcedure?.ProcedureIdentifier !== procedureId) return;
        if (response.error) {

        } else {
            this.currentProcedureSessions = response;
            this.procedureViews = response.length;
            this.latestView = response[0]?.StartTimeStamp || null;
            this.setMostAbandoned();
        }
        this.areSessionsLoaded = true;
    };

    getAllSessionNodes = (procedureId, sessions) => {
        let allNodes = {};
        for (let session of sessions) {
            for (let node of session.DebrifNodeEntries) {
                this.addNode(node, allNodes)
            }
        }
        return allNodes
    };

    addNode = (node, nodeObject) => {
        if (!node.NodeRef) {
            return
        }
        let ref = node.NodeRef.Identifier;
        if (nodeObject[ref]) {
            nodeObject[ref].viewed++;
            if (node.NodeEndTime) {
                nodeObject[ref].totalTimeInNode += (new Date(node.NodeEndTime).valueOf() - new Date(node.NodeStarTime).valueOf())
            } else {
                nodeObject[ref].abandoned++
            }
        } else {
            nodeObject[ref] = {viewed: 1};
            if (node.NodeEndTime) {
                nodeObject[ref].totalTimeInNode = new Date(node.NodeEndTime) - new Date(node.NodeStarTime);
                nodeObject[ref].abandoned = 0
            } else {
                nodeObject[ref].totalTimeInNode = 0;
                nodeObject[ref].abandoned = 1
            }
        }
    };

    async getProcedureVersions() {
        try{
            const procedureId = this.currentProcedure?.ProcedureIdentifier;
            const versions = await ProcedureRequester.getProcedureVersions(procedureId, generalStore.workspace);
            if (this.currentProcedure?.ProcedureIdentifier !== procedureId) return;
            this.procedureVersions = versions;
        } catch (e) {
            console.log(e)
        }

    }

    async getProcedureVersionDetail(versionNumber) {
        const procedureId = this.currentProcedure?.ProcedureIdentifier;
        return ProcedureRequester.getProcedureVersionDetail(procedureId, versionNumber, generalStore.workspace);
    }

    async getEditingVersions() {
        const procedureId = this.currentProcedure?.ProcedureIdentifier;
        const versions = await ProcedureRequester.getEditingVersions(procedureId, generalStore.workspace);
        if (this.currentProcedure?.ProcedureIdentifier !== procedureId) return;
        this.editingVersions = versions;
    }

    async editReleaseNotes(procedureId, versionObj) {
        await ProcedureRequester.editReleaseNotes(procedureId, versionObj, generalStore.workspace)
    }


    async rollback(procedureId, versionObj) {
        await ProcedureRequester.rollback(procedureId, versionObj, generalStore.workspace);
        await this.getProcedureVersions();
    }

    rollbackEditingVersion = async (procedureId, editVersionNumber, currentEditIdentifier) => {
        const updated = await ProcedureRequester.rollbackEditingVersion(procedureId, editVersionNumber, currentEditIdentifier, generalStore.workspace);
        await this.getEditingVersions();
        return updated;
    }

    duplicateProcedure = async (importedFromWorkspace, procedureId, currentProjectId) => {
        return await ProcedureRequester.duplicateProcedure(importedFromWorkspace, procedureId, currentProjectId, generalStore.workspace);
    }

    getNodeById = (nodeId, isPreview) => {
        const procedure = isPreview ? this.currentPreviewedProcedure : this.currentProcedure;
        const results = procedure.NestedNodes.filter(node => node.Identifier === nodeId);
        return results.length === 1 ? results[0] : null;
    }

    makeCurrentPreviewedStepCanonical() {
        const isCanonical = this.currentPreviewedStep !== -1;
        if (isCanonical) {
            return;
        }
        let currentNode = this.currentPreviewedNode;
        const allNodes = this.currentPreviewedProcedure.NestedNodes;

        let prevNode;
        do {
            // eslint-disable-next-line no-loop-func
            const possibleParentsArr = allNodes.filter(node => node.ConnectionsData.filter(c => c.ConnectedTo === currentNode.Identifier).length);
            if (!possibleParentsArr.length) {
                console.error('cannot find procedure node list');
                return;
            }

            prevNode = possibleParentsArr[0];

            const isSelectionStep = [procedureNodeTypeEnum.MULTI, procedureNodeTypeEnum.QUESTION].includes(prevNode.NodeType)
            if (isSelectionStep) {
                prevNode.userSelection = currentNode.Identifier;
            }
            currentNode = prevNode;

        } while (prevNode.NodeType); // if not start
    }

    setSessionViewerNode = (index, procedure) => {
        this.currentSessionIndex = index;
        this.currentPreviewedStepIndex = index >= 0 ? index : this.currentPreviewedStepIndex;  //in case the guide has a connection reference that does not exist
        this.currentPreviewedNode = !!procedure ? procedure.NestedNodes[index] : this.currentPreviewedNode;
        if (!!this.currentPreviewedNode.Style?.FloatDefaultPosition) {
            this.headerX = this.currentPreviewedNode.Style.FloatDefaultPosition.HeaderX || 0;
            this.headerY = this.currentPreviewedNode.Style.FloatDefaultPosition.HeaderY || 0;
        } else {
            this.headerX = 0;
            this.headerY = 0;
        }
        this.currentSession.Paused = !!this.currentPreviewedNode.isPaused //&& !this.currentSession.RunIn3D;
        this.setCurrentPreviewedMedia(0);
    }

    goToLog = (index, log, procedure) => {
        this.stopPlayer();
        this.setSessionViewerNode(index, procedure);
        this.currentSessionMilliSecond = log.logTime;
        this.startPlayer(procedure);
        if (log.mediaIndex !== null && log.mediaIndex !== false && Number(log.mediaIndex) > -1) {    //to include index of 0 with no false conversions
            this.currentMedia = log.mediaIndex
        }
    };

    tick = (procedure) => {
        const logs = this.sessionLogSteps;
        const endTime = logs[logs.length - 1].logEnd - 1;
        if (this.sessionPlayerRunning && this.currentSessionMilliSecond < endTime) {
            if (this.currentSessionMilliSecond + SESSION_PLAYER_INTERVAL < endTime) {
                this.currentSessionMilliSecond = this.currentSessionMilliSecond + SESSION_PLAYER_INTERVAL;
                this.setCurrentSessionIndex(logs, procedure);
            } else {
                this.currentSessionMilliSecond = endTime;
                this.setSessionViewerNode(logs.length - 1, procedure);
                clearInterval(this.intervalId)
                this.sessionPlayerRunning = false

            }
        } else {
            clearInterval(this.intervalId)
            this.sessionPlayerRunning = false
        }
    };

    playSession = (procedure) => {
        this.sessionPlayerRunning = true
        this.startPlayer(procedure)
    };
    pauseSession = () => {
        this.sessionPlayerRunning = false
    };

    startPlayer = (procedure) => {
        this.intervalId = setInterval(() => this.tick(procedure), SESSION_PLAYER_INTERVAL)
    }

    stopPlayer = () => clearInterval(this.intervalId)

    setCurrentSessionIndex = (logs, procedure) => {
        logs.forEach((log, i) => {
            const ceiledLogTime = Math.ceil(log.logTime / SESSION_PLAYER_INTERVAL) * SESSION_PLAYER_INTERVAL;
            const ceiledCurrentTime = Math.ceil(this.currentSessionMilliSecond / SESSION_PLAYER_INTERVAL) * SESSION_PLAYER_INTERVAL;
            if (ceiledLogTime === ceiledCurrentTime) {
                this.setSessionViewerNode(i, procedure);
                if (log.mediaIndex) {
                    this.currentMedia = log.mediaIndex
                }
            }
        });
    }

    setCurrentSecond = () => this.currentSessionMilliSecond = this.sessionLogSteps[this.currentSessionIndex].logTime

    skipLog = (factor, procedure) => {
        const increment = -1 * factor;
        const limit = this.sessionLogSteps.length - 1;
        let newIndex = this.currentSessionIndex + increment
        if (newIndex < 0) {
            newIndex = 0
        } else if (newIndex > limit) {
            newIndex = limit
        }
        this.setSessionViewerNode(newIndex, procedure);
        // this.currentSessionIndex = newIndex
        this.setCurrentSecond()
    };

    resetSession = () => {
        this.currentSessionIndex = 0;
        this.currentSessionMilliSecond = 0;
        this.sessionPlayerRunning = false;
        this.sessionViewerOpen = false;
        this.sessionLogSteps = [];
    };

    getSessionDuration = session => {
        return sharedUtils.renderDisplayTime(sharedUtils.getSessionDurationMillis(session))
    };

    getMediaAddedToSession = session => {
        let count = 0;
        for (let node of session.DebrifNodeEntries) {
            if (!!node.InputParams && !!node.InputParams.Value && node.InputParams.Type === inputTypeEnum.IMAGE) {
                count++
            }
        }
        return count
    };

    toggleTtsMuted = (isPreview) => {
        this.ttsMuted = !this.ttsMuted;
        if (!this.ttsMuted) {
            this.escapeAndSpeakDescription(isPreview)
        } else {
            this.shutUp();
        }
    }
    shutUp = () => {
        if (this.speakingInterval) {
            clearInterval(this.speakingInterval);
        }
        this.stopTTS();
    }
    startStreamSession = async (deepLink) => {
        return await ProcedureRequester.startStreamSession(deepLink, generalStore.workspace, this.currentProcedure.ProcedureIdentifier);
    }

    getPayPerClickStatus = async () => {
        try {
            return await ProcedureRequester.getPayPerClickStatus(generalStore.workspace, this.currentProcedure.ProcedureIdentifier);
        } catch (e) {
            console.warn(e)
        }
    }

    getPayPerClick = async payPerClickId => ProcedureRequester.getPayPerClick(generalStore.workspace, payPerClickId);

    deletePendingPayPerClick = async (payPerClickId) => {
        await ProcedureRequester.deletePendingPayPerClick(generalStore.workspace, payPerClickId);
    }

    updatePayPerClick = async payPerClick => await ProcedureRequester.updatePayPerClick(generalStore.workspace, payPerClick);

    updateMultipleConnections = async (modelId, markedProceduresSet) => {
        const markedProcedures = Array.from(markedProceduresSet);
        await ProcedureRequester.updateMultipleConnections(modelId, markedProcedures, generalStore.workspace);
    }

    resetCurrentSession = () => {
        this.currentSession = {
            StartTimeStamp: new Date(),
            DebrifNodeEntries: [],
            // RunIn3D: false,
            Paused: false,
            Docebo: {...this.doceboParams},
            DeviceIdentifier: Cookies.get('deviceId_v2')
        };
    }

    saveEditedProcedure = async (updatedNodes, createNewEditingVersion, languagesToAdd) => {
        const procedureId = this.currentProcedure.ProcedureIdentifier;
        const currentEditIdentifier = this.currentProcedure.CurrentEditIdentifier;
        const editingVersionNumber = this.currentProcedure.EditingVersionNumber;
        if (!procedureId) {
            return false
        }


        const procedureJson = {
            ProcedureIdentifier: this.currentProcedure.ProcedureIdentifier,
            NestedNodes: updatedNodes,
            UpdatedWithNewEditor: true,
            IsUpdateFromFlowEditor: true,
            languagesToAdd
        };

        this.currentProcedure.CurrentEditUsersTimeStamps = {
            ...this.currentProcedure.CurrentEditUsersTimeStamps,
            [generalStore.userDetails._id]: Date.now()
        };
        procedureJson.CurrentEditUsersTimeStamps = this.currentProcedure.CurrentEditUsersTimeStamps;

        if (!this.currentProcedure.DefaultLanguage) {
            this.currentProcedure.DefaultLanguage = languageEnum.ENGLISH_US;
            procedureJson.DefaultLanguage = languageEnum.ENGLISH_US;
        } else procedureJson.DefaultLanguage = this.currentProcedure.DefaultLanguage;

        const updatedProcedure = await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
        if (!!updatedProcedure) {
            this.currentProcedure = {...this.currentProcedure, ...updatedProcedure}

            GeneralRequester.sendAnalyticsEvent(
                'flow_edit_saved',
                generalStore.workspace,
                {
                    procedure_name: this.currentProcedure.ProcedureName,
                }
            ).catch(console.error);
        } else this.currentProcedure.NestedNodes = updatedNodes;
        return true
    }

    getAppChanges = async () => {
        const procedureId = this.currentProcedure.ProcedureIdentifier;
        return await ProcedureRequester.getAppChanges(procedureId, generalStore.workspace);
    }

    updatePreRequiredProcedures = async (preRequiredProcedures) => {
        const procedureId = this.currentProcedure.ProcedureIdentifier;
        if (!procedureId) {
            return false
        }

        const procedureJson = {
            ProcedureIdentifier: this.currentProcedure.ProcedureIdentifier,
            PreRequiredProcedures: preRequiredProcedures,
        };

        await ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace);
        this.currentProcedure.PreRequiredProcedures = preRequiredProcedures;
    }


    getUserDefinedInteractions = async (procedure, isHandleNewAnimation = false) => {
        try {
            if (isHandleNewAnimation) {
                return await projectStore.getAllUserDefinedInteractions(procedure.ProjectRef, [...this.currentProcedure.ThreeDModelsConnected]);
            }
            const interactions = await ProcedureRequester.getUserDefinedInteractions(generalStore.workspace, procedure.ProjectRef, [procedure.ProcedureIdentifier], true);
            this.procedureUserDefinedInteractions = new Map(interactions.map(interaction => [interaction.InteractiveStepID, interaction]));
        } catch (e) {
            console.error(e)
        }
    };

    deleteInteraction = async (interactionId, procedureId) => {
            console.log(procedureId)
        try {
            await ProcedureRequester.deleteInteraction(generalStore.workspace, interactionId, procedureId);
            return true
        } catch (e) {
            console.error(e);
            return false
        }
    }

    getAttached3dItems = async (missingItemsIds) => {
        if (!missingItemsIds.length) {
            return [];
        }
        return await ProcedureRequester.getAttached3dItems(generalStore.workspace, this.currentProcedure.ProcedureIdentifier, missingItemsIds, this.currentIsPublished);
    }

    ensureConnectedModelsInMap = async (modelIds) => {
        const projectId = projectStore.currentProject?.ProjectIdentifier;
        if (!projectId || !modelIds?.length) {
            return;
        }
        const projectProceduresMap = this.dataStore.projectsProceduresMap.get(projectId) || new ObservableMap();
        const missingIds = modelIds.filter(modelId => !projectProceduresMap.get(modelId)?.ObjectTargetItems);
        if (!missingIds.length) {
            return;
        }
        try {
            const fetchedModels = await this.getAttached3dItems(missingIds);
            fetchedModels?.forEach(model => projectProceduresMap.set(model.ProcedureIdentifier, model));
            this.dataStore.set('projectsProceduresMap', projectId, projectProceduresMap);
        } catch (error) {
            console.error('Failed to fetch connected 3D models:', error);
        }
    }

    getProcedureFromDataStore = (projectId, procedureId) => {
        if (!projectId || !procedureId) {
            return null
        }
        const projectsProceduresMap = this.dataStore.projectsProceduresMap.get(projectId);
        return projectsProceduresMap?.get(procedureId) || null;
    }

    getOrFetchFullProcedure = async (procedureId, workspace, published = false) => {
        if (this.currentProcedure?.ProcedureIdentifier === procedureId && this.currentProcedure.NestedNodes && this.currentIsPublished === published) {
            return this.currentProcedure;
        }
        const importedFromWorkspace = this.currentProcedure?.importedFromWorkspace;
        const procedureBeforeFetch = this.currentProcedure?.ProcedureIdentifier;
        const fetched = published
            ? await ProcedureRequester.getPublishedProcedure(procedureId, workspace)
            : await ProcedureRequester.getProcedure(procedureId, workspace);
        if (fetched && this.currentProcedure?.ProcedureIdentifier === procedureBeforeFetch) {
            if (importedFromWorkspace) fetched.importedFromWorkspace = importedFromWorkspace;
            this.currentProcedure = fetched;
            this.currentIsPublished = published;
        }
        return fetched;
    }

    getOrFetchAccessSources = (workspace, {itemId, nestedRoute}) => {
        const key = `${workspace}|${itemId}|${nestedRoute || ''}`;
        if (this.accessSourcesKey !== key) {
            this.accessSourcesKey = key;
            this.accessSourcesRequest = GroupsRequester.getItemAccessSources(workspace, {itemId, nestedRoute});
            this.accessSourcesRequest.catch(() => this.invalidateAccessSources(workspace, {itemId, nestedRoute}));
        }
        return this.accessSourcesRequest;
    }

    invalidateAccessSources = (workspace, {itemId, nestedRoute}) => {
        const key = `${workspace}|${itemId}|${nestedRoute || ''}`;
        if (this.accessSourcesKey === key) {
            this.accessSourcesKey = null;
            this.accessSourcesRequest = null;
        }
    }

    getProcedureSession = async (procedureSessionId) => {
        return await ProcedureRequester.getProcedureSession(generalStore.workspace, procedureSessionId);
    }

    getFlowEditorStatus = async procedureId => {
        return await ProcedureRequester.getFlowEditorStatus(generalStore.workspace, procedureId);
    }

    updateFlowEditorStatus = async (procedureId, currentEditIdentifier, editingVersionNumber) => {
        return await ProcedureRequester.updateFlowEditorStatus(generalStore.workspace, procedureId, currentEditIdentifier, editingVersionNumber);
    }

    createNextEditingVersionOnClose = () => {
        if (!!editorStore.editorRoomUsers.currentUsers.size) {
            return
        }

        const procedureId = this.currentProcedure.ProcedureIdentifier;
        const currentEditIdentifier = this.currentProcedure.CurrentEditIdentifier;
        const editingVersionNumber = this.currentProcedure.EditingVersionNumber;

        if (!procedureId || !currentEditIdentifier || !editingVersionNumber) {
            return
        }

        this.updateFlowEditorStatus(procedureId, currentEditIdentifier, editingVersionNumber + 1).then(result => {
            this.currentProcedure.CurrentEditIdentifier = result.currentEditIdentifier;
            this.currentProcedure.EditingVersionNumber = result.editingVersionNumber;
            this.currentProcedure.FlowEditorUsers = result.flowEditorUsers;
            this.getEditingVersions().then();
        });
    }

    getUpdateArray = (newArray, oldMap) => {
        const updateArray = [];
        newArray.forEach(element => {
            const elementId = element.id;
            let addToUpdateList;
            const oldElement = oldMap.get(elementId);
            if (!oldElement) {
                addToUpdateList = true
            } else {
                addToUpdateList = !Utility.getObjectsEqual(oldElement, element);
            }

            if (!!addToUpdateList) {
                updateArray.push(element);
            }
            oldMap.delete(elementId);
        });

        oldMap.forEach(remainingElementToBeDeleted => {
            remainingElementToBeDeleted.delete = true;
            updateArray.push(remainingElementToBeDeleted);
        })
        return updateArray;
    }

    getElementDiffs = (oldNodesArray, newNodesArray, oldConnectionsArray, newConnectionsArray) => {
        const oldNodesMap = new Map();
        const oldConnectionsMap = new Map();

        oldNodesArray.forEach(oldNode => {
            const nodeIsNotSubConnectionPoint = oldNode.type !== editorNodeTypeEnum.CONNECTION_POINT
            if (nodeIsNotSubConnectionPoint) {
                oldNodesMap.set(oldNode.id, oldNode);
            }
        });
        const nodeUpdatesWithSets = this.getUpdateArray(newNodesArray.filter(newNode => newNode.type !== editorNodeTypeEnum.CONNECTION_POINT), oldNodesMap);

        oldConnectionsArray.forEach(oldConnection => {
            if (this.getIsNotSubConnection(oldConnection)) {
                oldConnectionsMap.set(oldConnection.id, oldConnection);
            }
        });
        const connectionUpdatesWithMaps = this.getUpdateArray(newConnectionsArray.filter(newConnection => this.getIsNotSubConnection(newConnection)), oldConnectionsMap);

        const nodeUpdates = [];
        nodeUpdatesWithSets.forEach(node => {
            const updatedNode = this.convertNodeSetsToArrays(node);
            nodeUpdates.push(updatedNode);
        })

        const connectionUpdates = [];
        connectionUpdatesWithMaps.forEach(connection => {
            const updatedConnection = this.convertConnectionMapsToObjs(connection);
            connectionUpdates.push(updatedConnection);
        });

        return {nodeUpdates, connectionUpdates}
    }

    convertNodeSetsToArrays = node => {
        if (!!node.data?.handles) {
            node.data.handles = Utility.basicConvertSetToArray(node.data.handles);
        }
        if (!!node.data?.files) {
            node.data.files = Utility.basicConvertMapToObj(node.data.files);
        }
        if (!!node.data?.interactions) {
            const updatedInteractions = [];
            node.data.interactions.forEach(interaction => {
                interaction.interactionParams = Utility.basicConvertMapToObj(interaction.interactionParams);
                updatedInteractions.push(interaction);
            });
            node.data.interactions = updatedInteractions;
        }
        return node
    }

    convertNodeArraysToSets = node => {
        if (!!node.data?.handles) {
            node.data.handles = Utility.basicConvertArrayToSet(node.data.handles);
        }
        if (!!node.data?.files) {
            node.data.files = Utility.basicConvertObjToMap(node.data.files);
        }
        if (!!node.data?.interactions) {
            const updatedInteractions = [];
            node.data.interactions.forEach(interaction => {
                interaction.interactionParams = Utility.basicConvertObjToMap(interaction.interactionParams);
                updatedInteractions.push(interaction);
            });
            node.data.interactions = updatedInteractions;
        }
        return node
    }

    convertConnectionMapsToObjs = connection => {
        if (connection.data?.connectionPoints) {
            connection.data.connectionPoints = Utility.basicConvertMapToObj(connection.data.connectionPoints);
        }
        if (connection.data?.connectionLines) {
            connection.data.connectionLines = Utility.basicConvertMapToObj(connection.data.connectionLines);
        }
        return connection
    }

    convertConnectionObjsToMaps = connection => {
        if (connection.data?.connectionPoints) {
            connection.data.connectionPoints = Utility.basicConvertObjToMap(connection.data.connectionPoints);
        }
        if (connection.data?.connectionLines) {
            connection.data.connectionLines = Utility.basicConvertObjToMap(connection.data.connectionLines);
        }
        return connection
    }

    getNodeAndConnectionArrays = (nodeMap, connectionMap, includeEmptyConnections = false) => {
        const newNodesArray = [...nodeMap.values()];
        const newConnectionsArray = [];
        connectionMap.forEach((connectionSourceMap, nodeId) => {
            if (nodeMap.has(nodeId) && !!connectionSourceMap?.size) {
                connectionSourceMap.forEach(connection => {
                    if ((includeEmptyConnections && connection.isEmpty) || (!connection.isEmpty && !!connection.target && nodeMap.has(connection.data.finalTarget) && !!connection.data?.connectionPoints?.size)) {
                        newConnectionsArray.push(connection);
                        connection.data?.connectionPoints?.forEach(connectionPoint => {
                            connectionPoint.hidden = connection.hidden || connection.selected;
                            newNodesArray.push(connectionPoint);
                        });
                        connection.data?.connectionLines?.forEach(connectionLine => {
                            connectionLine.selected = connection.selected;
                            connectionLine.hidden = connection.hidden;
                            newConnectionsArray.push(connectionLine);
                        });
                    }
                });
            }
        });

        return {newNodesArray, newConnectionsArray};
    }

    getIsNotSubConnection = connection => !!editorStore.connections.has(connection.source) || connection.isEmpty;

    keepNodeCurrentLanguage = (node) => {
        if ([editorNodeTypeEnum.START, editorNodeTypeEnum.INNER_PROCEDURE].includes(node.type)) {
            return node;
        }
        const currentLanguage = this.currentProcedure.selectedLanguage || this.currentProcedure.DefaultLanguage || languageEnum.ENGLISH_US;
        const title = node.data.nodeData.StepHeaderMulti ? node.data.nodeData.StepHeaderMulti[currentLanguage] : node.data.nodeData.StepHeader;
        node.data.nodeData.StepHeader = title;
        node.data.label = Utility.removeHtmlTags(title);
        node.data.nodeData.ConfirmationText = node.data.nodeData.ConfirmationTextMulti ? node.data.nodeData.ConfirmationTextMulti[currentLanguage] : undefined;
        node.data.nodeData.StepText = node.data.nodeData.StepTextMulti ? node.data.nodeData.StepTextMulti[currentLanguage] : '';
        return node;
    }

    keepConnectionCurrentLanguage = (connection) => {
        const currentLanguage = this.currentProcedure.selectedLanguage || this.currentProcedure.DefaultLanguage || languageEnum.ENGLISH_US;
        const connectionLabel = connection.data.ConnectionNameMulti ? connection.data.ConnectionNameMulti[currentLanguage] : '';
        connection.data.ConnectionName = connectionLabel
        connection.label = connectionLabel;
        return connection;
    }

    addNodeUpdates = (userId, updatedNodeArray, nodeMap) => {
        const incomingUserSelectedNodes = editorStore.editorRoomUsers.currentUsers.get(userId)?.selectedNodeIds || new Set();
        const connectionsToDelete = new Set();
        updatedNodeArray.forEach(nodeWithArrays => {
            if (nodeWithArrays.delete) {
                incomingUserSelectedNodes.delete(nodeWithArrays.id);
                nodeMap.delete(nodeWithArrays.id);
                connectionsToDelete.add(nodeWithArrays.id);
            } else {
                const nodeWithOtherLanguage = this.convertNodeArraysToSets(nodeWithArrays);
                const node = this.keepNodeCurrentLanguage(nodeWithOtherLanguage);
                const nodeIsSelectedByOtherUser = node.selected;
                const nodeIsSelectedByThisUser = nodeMap.get(node.id)?.selected;
                if (nodeIsSelectedByOtherUser) {
                    incomingUserSelectedNodes.add(node.id);    //force incoming selection to avoid back-and-forth updates
                    const selectedState = nodeIsSelectedByThisUser ? false : nodeIsSelectedByThisUser;    //to catch the case of node.selected value being either undefined or false (and not cause a false positive for the node changing)
                    node.selected = selectedState;
                    node.data.selected = selectedState
                } else {
                    incomingUserSelectedNodes.delete(node.id);
                    node.selected = nodeIsSelectedByThisUser;
                    node.data.selected = nodeIsSelectedByThisUser;
                }
                nodeMap.set(node.id, node);
            }
        });
        return {nodeMap, incomingUserSelectedNodes, connectionsToDelete}
    }

    addConnectionUpdates = (updatedConnectionArray, connectionMap, isReorder = false) => {
        const connectionSourcesToReOrder = new Set();
        updatedConnectionArray.forEach(connectionWithObjs => {
            const connection = this.convertConnectionObjsToMaps(connectionWithObjs);
            let connectionSourceMap = connectionMap.get(connection.source) || new Map();
            if (connection.delete) {
                connectionSourceMap.delete(connection.sourceHandle);
            } else {
                const connectionCurrentLang = this.keepConnectionCurrentLanguage(connection);
                connectionSourceMap.set(connection.sourceHandle, connectionCurrentLang);
            }
            if (isReorder) {
                const sourceNode = editorStore.nodes.get(connection.source);
                if (sourceNode?.type === editorNodeTypeEnum.MULTI || sourceNode?.type === editorNodeTypeEnum.MULTI) {
                    connectionSourcesToReOrder.add(connection.source);
                }
            }
            connectionMap.set(connection.source, connectionSourceMap);
        });

        return {connectionMap, connectionSourcesToReOrder}
    }

    deleteConnections = (connectionsToBeDeleted, connectionMap) => {
        if (!connectionsToBeDeleted?.size) {
            return connectionMap
        }
        connectionsToBeDeleted.forEach(connectionToDelete => {
            connectionMap.delete(connectionToDelete);
        });
        connectionMap.forEach((connectionSourceMap, nodeId) => {
            connectionSourceMap.forEach((connection, handle) => {
                if (connection?.data?.finalTarget && connectionsToBeDeleted.has(connection.data.finalTarget)) {
                    connectionSourceMap.delete(handle);
                }
            });
            connectionMap.set(nodeId, connectionSourceMap);
        })
        return connectionMap
    }

    get updateDelayStillInEffect() {
        return Date.now() < this.lastUpdateTimeStamp + socketUpdateDelay;
    }

    get isSelectedLanguageDefault() {
        return !!this.currentProcedure && (!this.currentProcedure.selectedLanguage || this.currentProcedure.selectedLanguage === this.currentProcedure.DefaultLanguage);
    }

    connectWebSocket = async roomId => {
        this.socketRoomId = roomId + generalStore.workspace;
        await socket.emit('JoinRoom', roomId + generalStore.workspace);
    }

    disconnectWebSocket = () => {
        if (!!this.socketRoomId) {
            socket.emit('LeaveRoom', this.socketRoomId);
            this.socketRoomId = "";
        }
    }

    sendSocketMessage = data => {
        data.roomId = this.socketRoomId;
        socket.emit('EditorMessageOthers', JSON.stringify(data));
    }

    getSocketMessage = () => {
        socket.on('EditorMessageOthers', data => {
            this.handleEditorEvent(JSON.parse(data));
        })
    }

    stopGetSocketMessage = () => {
        socket.removeListener('EditorMessageOthers');
    }

    delayChangesUntilConnectedToCurrentRoomState = () => {
        modalStore.showInfoMessage(generalStore.translate('checkingForOtherUsersInFlowBuilder'))
        setTimeout(() => {
            editorStore.disableChanges = false;
            modalStore.showInfoMessage('');
        }, 3000);
    }

    joinFlowEditRoom = async roomId => {
        await this.connectWebSocket(roomId);
        await this.sendRequestUserData();
        editorStore.disableChanges = false;
    }

    leaveFlowEditRoom = () => {
        this.sendRemoveUser();
        this.disconnectWebSocket();
        editorStore.editorRoomUsers = {
            usedColors: new Set(),
            currentUsers: new Map()
        };
    }

    sendAddUserMessage = () => {
        const messageData = {
            editorEvent: "add-user",
            data: {
                userData: {
                    userId: generalStore.userDetails._id,
                    firstName: generalStore.userDetails.Name,
                    lastName: generalStore.userDetails.LastName,
                    userImage: generalStore.userDetails.UserIcon,
                },
                userSelectedNodeIds: editorStore.currentSelectedNodeIds
            }
        }
        this.sendSocketMessage(messageData);
    }

    sendRequestUserData = async () => {
        const messageData = {
            editorEvent: "request-user"
        }
        await this.sendSocketMessage(messageData);
    }

    sendRemoveUser = () => {
        const messageData = {
            editorEvent: "remove-user",
            data: {
                userId: generalStore.userDetails._id,
                firstName: generalStore.userDetails.Name,
                lastName: generalStore.userDetails.LastName,
            }
        }
        this.sendSocketMessage(messageData);
    }

    sendMouseMove = mouseData => {
        this.currentProcedure.FlowEditorLastUseTimeStamp = Date.now();
        this.currentProcedure.CurrentEditUsersTimeStamps = {
            ...this.currentProcedure.CurrentEditUsersTimeStamps,
            [generalStore.userDetails._id]: Date.now()
        };
        const mouseMoveDelayStillInEffect = this.lastMouseMoveTimeStamp > Date.now() - socketMouseDelay;
        if (mouseMoveDelayStillInEffect) {
            return
        } else this.lastMouseMoveTimeStamp = Date.now();
        const messageData = {
            editorEvent: "mouse-move",
            data: {
                userId: generalStore.userDetails._id,
                mouseData
            }
        }
        this.sendSocketMessage(messageData);
    }

    sendUpdateMessage = (oldNodesArray = null, oldConnectionsArray = null, isReorder = false) => {
        if (!oldNodesArray) {
            oldNodesArray = Utility.deepClone(editorStore.oldNodesArray);
        }
        if (!oldConnectionsArray) {
            oldConnectionsArray = Utility.deepClone(editorStore.oldConnectionsArray);
        }

        const {
            newNodesArray,
            newConnectionsArray
        } = this.getNodeAndConnectionArrays(editorStore.nodes, editorStore.connections, true);

        const processedNewNodesArray = Utility.deepClone(newNodesArray);
        const processedNewConnectionsArray = Utility.deepClone(newConnectionsArray);

        this.currentProcedure.CurrentEditUsersTimeStamps = {
            ...this.currentProcedure.CurrentEditUsersTimeStamps,
            [generalStore.userDetails._id]: Date.now()
        };

        const updateObj = this.getElementDiffs(oldNodesArray, processedNewNodesArray, oldConnectionsArray, processedNewConnectionsArray);
        if (!updateObj.nodeUpdates?.length && !updateObj.connectionUpdates?.length) {
            return
        }

        const messageData = {
            editorEvent: isReorder ? "update-reorder" : "update",
            data: {
                userId: generalStore.userDetails._id,
                updateObj
            }
        }
        this.sendSocketMessage(messageData);

        editorStore.oldNodesArray = Utility.deepClone(newNodesArray);
        editorStore.oldConnectionsArray = Utility.deepClone(newConnectionsArray);
    }

    sendGetCurrentState = userId => {
        const {
            newNodesArray: currentNodesArray,
            newConnectionsArray: currentConnectionsArray
        } = this.getNodeAndConnectionArrays(editorStore.nodes, editorStore.connections, true);

        const oldNodesArray = currentNodesArray?.filter(node => node.type !== editorNodeTypeEnum.CONNECTION_POINT).map(node => this.convertNodeSetsToArrays(node)) || [];
        const oldConnectionsArray = currentConnectionsArray?.filter(connection => this.getIsNotSubConnection(connection)).map(connection => this.convertConnectionMapsToObjs(connection)) || [];

        // const currentObjWithMapsConverted = this.getElementDiffs([], currentNodesArray, [], currentConnectionsArray);

        const messageData = {
            editorEvent: "get-current-state",
            data: {
                userId,
                oldNodesArray,
                oldConnectionsArray
            }
        }
        this.sendSocketMessage(messageData);
    }

    handleEditorEvent = eventData => {
        const {editorEvent, data} = eventData;
        switch (editorEvent) {
            case "add-user":
                if (!editorStore.sentInitialUser) {
                    this.sendAddUserMessage();
                }
                this.addEditorUser(data, !editorStore.sentInitialUser);
                editorStore.sentInitialUser = true;
                break
            case "request-user":
                editorStore.sentInitialUser = true;     //if first user, ensures it does not request nodes when others join
                this.sendAddUserMessage();
                break
            case "remove-user":
                this.removeEditorUser(data);
                break
            case "mouse-move":
                this.updateUserMouse(data);
                break
            case "node-selected":
                this.userSelectedNode(data);
                break
            case "node-deselected":
                this.removeUserNodeSelection(data);
                break
            case "update":
                this.updateFlowEditor(data);
                break
            case "update-reorder":
                this.updateFlowEditor(data, true);
                break
            case "get-current-state":
                this.getCurrentState(data);
                break
            default:
                break
        }
    }

    addEditorUser = (data, requestOtherUserNodes = false) => {
        const {userData, userSelectedNodeIds} = data;
        const userId = userData?.userId;
        let existingAvatarColor;
        if (editorStore.editorRoomUsers.currentUsers.has(userId)) {
            existingAvatarColor = editorStore.editorRoomUsers.currentUsers.get(userId).avatarColor;
        }
        if (!existingAvatarColor) {
            const availableColors = colorsArray.filter(color => !editorStore.editorRoomUsers.usedColors.has(color));
            const avatarColor = availableColors[Math.floor(Math.random() * availableColors.length)];
            editorStore.editorRoomUsers.usedColors.add(avatarColor);
            userData.avatarColor = avatarColor;
        } else userData.avatarColor = existingAvatarColor;
        userData.selectedNodeIds = new Set(userSelectedNodeIds || []);
        userData.timeStamp = Date.now();
        editorStore.editorRoomUsers.currentUsers.set(userId, userData);
        if (requestOtherUserNodes) {
            this.sendGetCurrentState(userId);
        }
    }

    removeEditorUser = editorUser => {
        const {userId} = editorUser;
        const storedUser = editorStore.editorRoomUsers.currentUsers.get(userId);
        if (!storedUser) {
            return
        }
        editorStore.editorRoomUsers.usedColors.delete(storedUser.avatarColor);
        editorStore.editorRoomUsers.currentUsers.delete(userId);
    }

    updateUserMouse = userData => {
        const {userId, mouseData} = userData;
        const storedUser = editorStore.editorRoomUsers.currentUsers.get(userId);
        if (!mouseData || !storedUser || userId === generalStore.userDetails._id) {
            return
        }
        storedUser.mouseData = mouseData;
        storedUser.timeStamp = Date.now();
        editorStore.editorRoomUsers.currentUsers.set(userId, storedUser);
    }

    updateUserSelectedNodes = (userData, updateSelf = false) => {
        const {userId, nodeIdSet} = userData;
        const storedUser = editorStore.editorRoomUsers.currentUsers.get(userId);
        if (!nodeIdSet || !storedUser || (!updateSelf && userId === generalStore.userDetails._id)) {
            return
        }

        storedUser.selectedNodeIds = nodeIdSet;
        storedUser.timeStamp = Date.now();
        editorStore.editorRoomUsers.currentUsers.set(userId, storedUser);
    }

    updateFlowEditor = (updateData, isReorder = false) => {
        editorStore.resetChangeHistory();
        const {userId, updateObj} = updateData;
        const storedUser = editorStore.editorRoomUsers.currentUsers.get(userId);
        if (!updateObj || !storedUser || userId === generalStore.userDetails._id) {
            return
        }

        this.lastUpdateTimeStamp = Date.now() + 200;
        let connectionsToBeDeleted;

        if (!!updateObj.nodeUpdates?.length) {
            const {
                nodeMap,
                incomingUserSelectedNodes,
                connectionsToDelete
            } = this.addNodeUpdates(userId, updateObj.nodeUpdates, editorStore.nodes);
            editorStore.nodes = new ObservableMap(nodeMap);
            connectionsToBeDeleted = connectionsToDelete;
            this.updateUserSelectedNodes({
                userId,
                nodeIdSet: incomingUserSelectedNodes
            });
        }

        if (!!updateObj.connectionUpdates?.length || !!connectionsToBeDeleted.size) {
            const {
                connectionMap,
                connectionSourcesToReOrder
            } = this.addConnectionUpdates(updateObj.connectionUpdates, editorStore.connections, isReorder);
            this.deleteConnections(connectionsToBeDeleted, connectionMap);

            if (isReorder) {
                connectionSourcesToReOrder?.forEach(nodeId => {
                    const correctlyOrderedConnectionSourceMap = new Map();
                    const sourceNode = editorStore.nodes.get(nodeId);
                    const connectionSourceMap = connectionMap.get(nodeId);
                    sourceNode?.data?.handles?.forEach(handle => {
                        const connection = connectionSourceMap.get(handle);
                        correctlyOrderedConnectionSourceMap.set(handle, connection);
                    });
                    connectionMap.set(nodeId, correctlyOrderedConnectionSourceMap);
                });
                connectionSourcesToReOrder?.forEach(nodeId => {
                    const sourceNode = editorStore.nodes.get(nodeId);
                    editorStore.nodes.delete(nodeId);
                    editorStore.nodes = new ObservableMap(editorStore.nodes);
                    setTimeout(() => {
                        editorStore.nodes.set(nodeId, sourceNode);
                        editorStore.nodes = new ObservableMap(editorStore.nodes);

                    })
                });
            }
            editorStore.connections = new ObservableMap(connectionMap);
        }

        storedUser.timeStamp = Date.now();
        editorStore.editorRoomUsers.currentUsers.set(userId, storedUser);
        editorStore.disableChanges = false;

    }

    getCurrentState = data => {
        const {userId, oldNodesArray, oldConnectionsArray} = data;
        if (userId === generalStore.userDetails._id) {
            this.sendUpdateMessage(
                Utility.deepClone(oldNodesArray.map(node => this.convertNodeArraysToSets(node))),
                Utility.deepClone(oldConnectionsArray.map(connection => this.convertConnectionObjsToMaps(connection))),
            );
        }
        editorStore.disableChanges = false;
    }

    getAndApplyInAppChanges = async () => {
        try {
            const appChanges = await this.getAppChanges()
            if (appChanges?.existingChanges && appChanges.existingChanges.length) {
                await editorStore.applyInappNodeChanges(appChanges.existingChanges.map(change => change.NodeChanged), appChanges.allInteractions);
                if (appChanges?.existingChanges.length === 1) {
                    const [singleChange] = appChanges?.existingChanges;
                    const hasInteractionChange = singleChange.ChangedFields.includes('NodeInteractionItems');
                    if (hasInteractionChange) {
                        const changedNode = editorStore.nodes.get(singleChange.NodeChanged.Identifier);
                        const interactions = changedNode.data.interactions;
                        const newAnimation = interactions[interactions.length-1]?.ActionName;

                        const rawHeader = changedNode.data.nodeData.StepHeaderMulti?.[this.currentProcedure.selectedLanguage]
                            ?? changedNode.data.nodeData.StepHeader;
                        const stepHeader = Utility.removeHtmlTags(rawHeader);
                        modalStore.showInfoMessage(`${newAnimation}: animation added to ${stepHeader}`);
                        await Utility.sleep(10000);
                        modalStore.showInfoMessage('');
                    }
                } else {
                    modalStore.showInfoMessage(generalStore.translate('flowUpdatedExternally'));
                    await Utility.sleep(10000);
                    modalStore.showInfoMessage('');
                }
            }
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('failedToUpdateChangesFromApp'));
        }
    }

    saveProcedure = async (createNewEditingVersion = false, languagesToAdd = []) => {
        this.editorSaveCount++;
        try {
            if (createNewEditingVersion) {
                generalStore.isLoaderOpen = true;
            }

            await this.getAndApplyInAppChanges();

            const updatedNodes = editorStore.generateUpdatedNodes(editorStore.nodes);
            const success = await this.saveEditedProcedure(updatedNodes, createNewEditingVersion, languagesToAdd);
            generalStore.isLoaderOpen = false;
            if (!success) {
                modalStore.showErrorMessage(generalStore.translate('problemSavingProcedure'));
            } else {
                this.updateProcedureInStores(this.currentProcedure);
            }
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('problemSavingProcedure'));
        }
    }

    exitProcedureEditor = ({ useBeacon } = {}) => {
        const procedureJson = {ProcedureIdentifier: this.currentProcedure.ProcedureIdentifier}
        if (!!this.currentProcedure.CurrentEditUsersTimeStamps) {
            delete this.currentProcedure.CurrentEditUsersTimeStamps[generalStore.userDetails._id];
        } else this.currentProcedure.CurrentEditUsersTimeStamps = {}
        procedureJson.CurrentEditUsersTimeStamps = this.currentProcedure.CurrentEditUsersTimeStamps;
        if (useBeacon) {
            ProcedureRequester.exitEditorBeacon(procedureJson, generalStore.workspace);
        } else {
            ProcedureRequester.createOrUpdateProcedure(procedureJson, generalStore.workspace).then();
        }
    }

    buildEditorUrl = () => {
        const procedure = this.currentProcedure;
        const urlParams = {
            db: generalStore.workspace,
            projectId: procedure.ProjectRef,
            folderId: procedure.ParentFolder,
            procedureId: procedure.ProcedureIdentifier
        };
        return Utility.buildUrl(routes.EDITOR, urlParams);
    }
    goToEditor = async () => {
        const editorLink = this.buildEditorUrl();
        history.push(editorLink);
    }
    checkIfTooManyProcedureActiveEditors = async () => {
        return await ProcedureRequester.checkIfTooManyProcedureActiveEditors(this.currentProcedure.ProcedureIdentifier, generalStore.workspace);
    }

    updateProcedureInStores = procedure => {
        this.currentProcedure = procedure;
        const procedureId = procedure.ProcedureIdentifier;
        const projectId = procedure.ProjectRef;
        const projectProceduresMap = this.dataStore.projectsProceduresMap.get(projectId) || new Map();
        projectProceduresMap.set(procedureId, this.currentProcedure);
        this.dataStore.set('projectsProceduresMap', projectId, projectProceduresMap);
        this.dataStore.set('projectsProceduresExpirationMap', projectId, Date.now() + DATA_INTERVAL);
    }
    addNewInteractionFolder = async (folderId, newFolderName, procedureId, projectId) => {
        const fakeInteractionJson = {
            InteractiveStepID: uuidv4(),
            ProcedureRef: procedureId,
            ProjectRef: projectId,
            ActionName: `__${newFolderName}`,
            InteractiveIOPath: folderId,
            InteractiveData: null,
        }
        try {
            const newFakeInteraction = await ProcedureRequester.upsertInteraction(generalStore.workspace, fakeInteractionJson);
            if (!newFakeInteraction) {
                modalStore.showErrorMessage(generalStore.translate('problemSavingNewlyCreatedInteractionFolder'));
                return false
            } else {
                this.procedureUserDefinedInteractions.set(newFakeInteraction.InteractiveStepID, newFakeInteraction);
                return true;
            }
        } catch (e) {
            let errMessage;
            if (e.response && e.response.status === responseEnum.DUPLICATE) {
                errMessage = 'thatFolderNameAlreadyExistsForThisModel';
            } else errMessage = 'problemSavingNewlyCreatedInteractionFolder';
            modalStore.showErrorMessage(generalStore.translate(errMessage));
            console.error(e);
            return false
        }
    }

    updateInteractionFolderName = async (oldFolderPath, newFolderPath, loadFolderTree, procedureId) => {
        const oldProcedureInteractions = new Map(this.procedureUserDefinedInteractions);
        this.updateInteractionFolders(oldFolderPath, newFolderPath, loadFolderTree);

        const projectId = this.currentProcedure.ProjectRef;
        try {
            await ProcedureRequester.updateFolderPaths(generalStore.workspace, oldFolderPath, newFolderPath, projectId, procedureId);
            return true
        } catch (e) {
            console.error(e);
            this.procedureUserDefinedInteractions = oldProcedureInteractions;
            loadFolderTree(true);
            return false
        }
    }

    updateInteractionFolders = (oldFolderPath, newFolderPath, loadFolderTree) => {
        return new Promise((resolve) => {
            const updatedInteractions = new Map();

            this.procedureUserDefinedInteractions.forEach((interaction, key) => {
                if (!!interaction?.InteractiveIOPath && interaction.InteractiveIOPath?.search(new RegExp(`^${oldFolderPath}.*$`, 'i')) >= 0) {
                    interaction.InteractiveIOPath = interaction.InteractiveIOPath.replace(oldFolderPath, newFolderPath)
                }
                updatedInteractions.set(key, interaction);
            });
            this.procedureUserDefinedInteractions = updatedInteractions;

            const result = loadFolderTree(true);
            resolve(result);
        });
    };

    updateInteraction = async (interaction) => {
        try {
            return await ProcedureRequester.upsertInteraction(generalStore.workspace, interaction);
        } catch (e) {
            console.error(e);
            return false
        }
    }

    duplicateInteractionAnimation = async (interactionId, procedureId) => {
        try {
            return await ProcedureRequester.duplicateAnimation(generalStore.workspace, interactionId, procedureId);
        } catch (e) {
            console.error(e);
            return false
        }
    }

    createNewEmptyInteraction = async (folderPath, procedure) => {
        const interactionId = uuidv4();
        const newInteractionJson = {
            InteractiveStepID: interactionId,
            InteractiveIOPath: folderPath,
            ProcedureRef: procedure.ProcedureIdentifier,
            ProjectRef: procedure.ProjectRef,
            InteractionData: "{}"
        }
        try {
            const newInteraction = await ProcedureRequester.upsertInteraction(generalStore.workspace, newInteractionJson);
            return newInteraction.InteractiveStepID;
        } catch (e) {
            console.error(e);
            return null
        }
    }

    deleteInteractionFolder = async (folderPathWithoutRoot, loadFolderTree, procedureId) => {
        console.log(procedureId);
        const oldProcedureInteractions = new Map(this.procedureUserDefinedInteractions);
        const updatedInteractions = new Map();

        this.procedureUserDefinedInteractions.forEach((interaction, key) => {
            if (!interaction?.InteractiveIOPath || interaction.InteractiveIOPath?.search(new RegExp(`^${folderPathWithoutRoot}.*$`, 'i')) < 0) {
                updatedInteractions.set(key, interaction);
            }
        });
        this.procedureUserDefinedInteractions = updatedInteractions;
        loadFolderTree(true);

        const projectId = this.currentProcedure.ProjectRef;
        try {
            await ProcedureRequester.deleteInteractionFolder(generalStore.workspace, folderPathWithoutRoot, projectId, procedureId);
            return true
        } catch (e) {
            console.error(e);
            this.procedureUserDefinedInteractions = oldProcedureInteractions;
            loadFolderTree(true);
            return false
        }
    }

    populateFavoriteProcedures = async () => {
        try {
            const favoriteProcedures = await ProcedureRequester.getFavoriteProcedures(generalStore.workspace);
            this.favoriteProcedures = new ObservableMap(favoriteProcedures.map(procedure => [procedure.ProcedureIdentifier, procedure]));
        } catch (e) {
            console.error(e);
        }
    }

    addFavoriteProcedure = async (procedure) => {
        const {ProcedureIdentifier: procedureId, ProjectRef: projectRef} = procedure;
        try {
            this.favoriteProcedures.set(procedureId, {
                ...procedure,
                ProcedureType: !!procedure.ProcedureType || procedure.ProcedureType === 0 ? procedure.ProcedureType : procedure.ItemType,
                DateCreated: new Date()
            });
            await ProcedureRequester.addFavoriteProcedure(generalStore.workspace, projectRef, procedureId);
            modalStore.showInfoMessage(generalStore.translate('addedToFavorites'));
            Utility.sleep(1000).then(() => modalStore.alertMessage = '');
        } catch (e) {
            this.favoriteProcedures.delete(procedureId);
            modalStore.showErrorMessage(generalStore.translate('problemSavingNewFavoriteProcedure'));
            console.error(e);
        }
    }

    removeFavoriteProcedure = async (procedureId) => {
        const backupFavorite = this.favoriteProcedures.get(procedureId);
        try {
            this.favoriteProcedures.delete(procedureId);
            await ProcedureRequester.removeFavoriteProcedure(generalStore.workspace, procedureId);
            modalStore.showInfoMessage(generalStore.translate('removedFromFavorites'));
            Utility.sleep(1000).then(() => modalStore.alertMessage = '');
        } catch (e) {
            this.favoriteProcedures.set(procedureId, backupFavorite);
            modalStore.showErrorMessage(generalStore.translate('problemRemovingFavoriteProcedure'));
            console.error(e);
        }
    }
}
